import React, { use, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "./style.css";
import "../Settings/SearchScreen/style.css";
import { Helmet } from "react-helmet-async";
import NavbarTop from "../../components/NavbarTop";
import axios from "axios";
import { useAuth, useTheme } from "../../global-components/src";
import { Community, ImagePost, Post, StatusString, Story, UserStories } from "../../types";
import { useMessage } from "../../global-components/src";
import ImgVerified from "../../components/imgVerified/ImgVerified";
import { Copy, Image as ImageIcon, MessageCircle, Settings, UserX } from "react-feather";
import { errorMessage } from "../../utils/TextManagerTwo";
import Spinner, { LoadingThreeCircle } from "../../global-components/src/components/spinner/spiner";
import ShareProfile from "../../components/Post/Config/ShareProfile/ShareProfile";
import BlockUser from "../../components/Post/Config/BlockUser";
import ReportModal from "../../components/Modals/Report";
import Report from "../../components/Post/Config/Report";
import WarnUserDropdown from "../../components/Post/Config/WarnUserDropdown/WarnUserDropdown";
import RemovePictureProfile from "../../components/RemovoPictureProfile";
import ConfirmationModal from "../../components/Modals/ConfirmationModal";
import BanUser from "../../components/Modals/BanUser/BanUser";
import UnbanUser from "../../components/Modals/UnbanUser/UnbanUser";
import PostList from "../../components/Post/PostList";
import WarnUser from "../../components/Modals/WarnUser/WarnUser";
import OpenImg from "../../components/Modals/OpenImg/OpenImg";
import RemoveAccount from "../../components/RemoveAccount";
import ModalPostLikes from "../Posts/PostLikes/ModalPostLikes";
import ReactPlayer from "react-player";
import NotFound from "../errors/NotFound";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { Playlist, TmdbSearchResult, User, VideoPlaylist, WatchedMedia } from "../../global-components/src/types";
import { getImageUser, getImageUserNotFound, isEveryOnline } from "../../global-components/src/utils/auth";
import { ArrowLeft, Building, Building2, Cake, Calendar, CheckCircle, Crown, Flame, GalleryHorizontalEnd, Heart, ImageOff, Images, Info, KeyboardOff, Link2, Locate, Mail, MapPin, MapPinned, MapPlus, Medal, Menu, Music2, PanelsTopLeft, Pencil, Phone, Podium, ScrollText, Search, Settings2, SlidersHorizontal, Trash2, UserMinus2, Users, VenusAndMars, Video, X } from "lucide-react";
import ModalCommentsBottom from "../../components/Modals/comments/comments-bottom";
import BottomSheet from "../../components/bottom-sheet/bottom-sheet";
import {
    LeftContent,
    RightContent,
    SponsoredContent,
} from "../../global-components/src/components/screen/left-content";
import { debounce, set } from "lodash";
import { IconLateralContent } from "../../global-components/src/components/screen/icon-lateral-content";
import { UserSearchLoadin } from "../Settings/SearchScreen/User/UserSearchLoading";
import UserSearch from "../Settings/SearchScreen/User/User";
import { getImageNotFound, getImagePathBucketPacoca } from "../../global-components/src/utils/utils";
import EditAccount from "../../components/edit-account";
import { PostLoading } from "../../components/Post/post-loading";
import { formatNumber } from "../../utils/numbers";
import ReactCrop, { centerCrop, convertToPixelCrop, makeAspectCrop, PercentCrop } from "react-image-crop";
import { getNativeStatusBarHeight, isIOSWebView, isNewApp, isWebView, removeToNativeiOS } from "../../utils/platform";
import setCanvasPreview from "../../setCanvasPreview";
import { Icon } from "../../global-components/src/components/icon";
import { Frame } from "../../components/Post/ImgProfilePost/frame";
import ModalComments from "../../components/Modals/comments/modal-comments";
import Transfer from "../../components/wallet/drop-transfer";
import GiveCoffee from "../../components/Modals/give-coffee/give-coffee";
import GiveCoffeeBottom from "../../components/Modals/give-coffee/give-coffee-bottom";
import { censorText, clearText, normalizeLineBreaks } from "../../global-components/src/utils/text";
import AddBanner from "../../components/add-banner";
import ImageCropModal from "../../components/image-crop-modal";
import { t } from "i18next";
import { compressImage, convertHeic } from "../../global-components/src/utils/file";
import { uploadToSignedUrl } from "../../utils/signed-upload";
import { api } from "../../services/api";
import { useFeed } from "../../contexts/FeedContext";
import StoryViewer from "../../components/stories/story-viewer";
import ImageModal from "../../components/Post/ImgPost/image-modal";
import MuteUser from "../../components/Post/Config/MuteUser";
import PacocarUser from "../../components/Post/Config/PacocarUser";
import { useTranslation } from 'react-i18next';
import ContributionGraph from "../../components/contribution-graph/contribution-graph";
import { canAnimateProfilePhoto, FreezeGif } from "./freeze-gif";

type EnumContent = "photos" | "all" | "communities" | "poems" | "musics" | "filmes"
const ASPECT_RATIO = 1;
const MIN_DIMENSION = 150;

const Account: React.FC = () => {
    const [reportIdUser, setReportIdUser] = useState<number | null>(null);
    const [reportIdPost, setReportIdPost] = useState<number | null>(null);
    const { token, user: userAuthenticated, logout, setUser: setUserAuthenticated, isSuper } = useAuth();
    const _location = useLocation();
    const [user, setUser] = useState<User | null>(null);
    const { setMessage } = useMessage();
    const { t } = useTranslation();
    const [userName, setUserName] = useState<string | null>(null);
    const [notFound, setNotFound] = useState<boolean>(false);
    const [errorLoad, setErrorLoad] = useState<boolean>(false);
    const [isFollowing, setIsFollowing] = useState<boolean | undefined>(user?.is_following);
    const [isFollowed, setIsFollowed] = useState<boolean | undefined>(user?.is_followed);
    const navigate = useNavigate();
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showConfirmationBanner, setShowConfirmationBanner] = useState(false);
    const [showConfirmationRemoveAccount, setShowConfirmationRemoveAccount] = useState(false);
    const [password, setPassword] = useState(''); // Adicione um estado para a senha
    const [contentAccount, setContentAccount] = useState<EnumContent | null>("all");
    const [isBanned, setIsBanned] = useState(user?.is_banned ? (user?.is_banned === true ? true : new Date(user?.is_banned)) : null); // Adicione um estado para a senha
    const [isWarned, setIsWarned] = useState(false); // Adicione um estado para a senha
    const [errorModal, setErrorModalPassword] = useState(''); // Adicione um estado para a senha
    const [errorModalRemoveAccount, setErrorModalRemoveAccountPassword] = useState(''); // Adicione um estado para a senha
    const closeRef = useRef<HTMLButtonElement | null>(null);
    const openImgRef = useRef<HTMLButtonElement | null>(null);
    const closeRefDeleteAccount = useRef<HTMLButtonElement | null>(null);
    const [photos, setPhotos] = useState<ImagePost[]>([]);
    const [photoPosts, setPhotoPosts] = useState<Post[]>([]);
    const [selectedPhotoPost, setSelectedPhotoPost] = useState<Post | null>(null);
    const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(0);
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [posts, setPosts] = useState<Post[]>([]);
    const [poems, setPoems] = useState<Post[]>([]);
    const [cursor, setCursor] = useState<number | null>(null);
    const [cursorPoem, setCursorPoem] = useState<number | null>(null);
    const [playlists, setPlaylists] = useState<Playlist[]>([]);
    const [selectedPlaylist, setSelectedPlaylist] = useState<Playlist | null>(null);
    const [videos, setVideos] = useState<VideoPlaylist[]>([]);
    const [loadingVideos, setLoadingVideos] = useState(false);
    const [end, setEnd] = useState(false);
    const [endPhotos, setEndPhotos] = useState(false);
    const [error, setError] = useState("");
    const [page, setPage] = useState(1);
    const [pagePoem, setPagePoem] = useState(1);
    const [pageImage, setPageImage] = useState(1);
    const [isNotFoundPage, setIsNotFoundPage] = useState(false);
    const endOfListRef = useRef<HTMLDivElement | null>(null);
    const observerRef = useRef<IntersectionObserver | null>(null);
    const [openImage, setOpenImage] = useState<number | null>(null);
    const location = _location;
    const path = location.pathname;
    const pageUrl = `${window.location.origin}${location.pathname}`;
    const [communities, setCommunities] = useState<Community[]>([]);
    const [members, setMembers] = useState<User[]>([]);
    const [followings, setFollowings] = useState<User[]>([]);
    const [statusMembers, setStatusMembers] = useState<StatusString>(StatusString.loading);
    const [statusFollowing, setStatusFollowing] = useState<StatusString>(StatusString.loading);
    const limitImage = window.innerWidth <= 850 ? 10 : 20;
    const [isOpenProfile, setIsOpenProfile] = useState(false);
    const [isOpenBanner, setIsOpenBanner] = useState(false);
    const [statusCommunities, setStatusCommunities] = useState<StatusString>(StatusString.loading);
    const [showMoreInfo, setShowMoreInfo] = useState<boolean>(false);
    const [playlistUrl, setPlaylistUrl] = useState("");
    const [loadingAddPlaylist, setLoadingAddPlaylist] = useState(false);
    const [openProfileOptions, setOpenProfileOptions] = useState(false);
    const [openTabsSheet, setOpenTabsSheet] = useState(false);
    // filter panel — mobile: bottom-sheet; desktop: side panel
    const [openPostFilters, setOpenPostFilters] = useState(false);   // mobile bottom-sheet
    const [filterPanelRendered, setFilterPanelRendered] = useState(false); // desktop panel mounted
    const [filterPanelEntering, setFilterPanelEntering] = useState(false); // desktop slide-in
    const filterPanelRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const [filterKeyword, setFilterKeyword] = useState("");
    const [filterKeywordInput, setFilterKeywordInput] = useState("");
    const [filterOldestFirst, setFilterOldestFirst] = useState(false);
    const [filterHasLink, setFilterHasLink] = useState(false);
    const [filterMediaType, setFilterMediaType] = useState<"" | "photos" | "videos">("");
    const ogImage = "/img/pacoca-sem-braco-rounded.png";
    const schemaMarkup = {
        "@context": "https://schema.org",
        "@type": "Person",
        "name": user?.name,
        "url": pageUrl,
        "description": `${user?.biography ? user?.biography : `Veja o perfil de ${user?.name} na Paçoca, a rede social 100% brasileira para criar conexões e compartilhar momentos!`}`,
        "image": getImageUser(user?.img_account) || ogImage,
        "sameAs": [
            `https://paçoca.com/@${user?.user_name}`
        ]
    };
    
    const isPoems = useMemo(() => contentAccount === "poems", [contentAccount]);
    // 1. Adicione o hook
    const [searchParams] = useSearchParams();
    const shouldOpenStoryComments = ["1", "true"].includes(
        searchParams.get("comments")?.toLowerCase() ?? "",
    );

    // 2. Estados para o story viewer
    const [usersStoriesProfile, setUsersStoriesProfile] = useState<UserStories[]>([]);
    const [activeUserIndex, setActiveUserIndex] = useState<number | null>(null);
    const [activeStoryIndex, setActiveStoryIndex] = useState(0);

    const fetchAndOpenStory = async (targetStoryId?: number) => {
        try {
            const response = await api(token).get("/stories", {
                params: { id_user: user?.id }
            });

            const stories: Story[] = response.data.data;
            if (!stories.length) return;

            setUsersStoriesProfile([{ user: user!, stories }]);

            // Se veio um id específico (notificação), abre nele; senão abre no primeiro
            const storyIndex = targetStoryId
                ? stories.findIndex(s => s.id === targetStoryId)
                : 0;

            setActiveUserIndex(0);
            setActiveStoryIndex(storyIndex !== -1 ? storyIndex : 0);

        } catch (err) {
            console.error("Erro ao carregar story", err);
        }
    };

    
    // No useEffect da notificação:
    useEffect(() => {
        const storyId = searchParams.get("story");
        if (!storyId || !user?.id) return;

        fetchAndOpenStory(Number(storyId)); // ← passa o id específico
    }, [user?.id, searchParams]);

    const visiblePosts = useMemo(() => {
        return isPoems ? poems : posts;
    }, [isPoems, poems, posts]);

    // Armazenando a posição de rolagem
    const [showModalLikes, setShowModalLikes] = useState(false);
    const [showModalComments, setShowModalComments] = useState(false);
    const [idPostSelected, setIdPostSelected] = useState<number | null>(null)
    // loadings
    const [isLoading, setIsLoading] = useState(false); //
    const [isLoadingImages, setLoadingImages] = useState(false); // imagens
    const [loadingPlaylists, setLoadingPlaylists] = useState(false); // playlists
    const [watchedMedia, setWatchedMedia] = useState<WatchedMedia[]>([]);
    const [loadingWatchedMedia, setLoadingWatchedMedia] = useState(false);
    const [watchedMediaSearch, setWatchedMediaSearch] = useState('');
    const [watchedMediaResults, setWatchedMediaResults] = useState<TmdbSearchResult[]>([]);
    const [loadingWatchedSearch, setLoadingWatchedSearch] = useState(false);
    const [addingWatchedMedia, setAddingWatchedMedia] = useState<number | null>(null); // tmdb_id em processo
    const [removingWatchedMedia, setRemovingWatchedMedia] = useState<number | null>(null); // id do item
    const TMDB_IMAGE_BASE = 'https://image.tmdb.org/t/p/w200';
    const [isLoadingPosts, setLoadingPosts] = useState(false); // posts
    const [loading, setLoading] = useState(true); //
    const [imgPath, setImgPath] = useState("");
    const [openSettings, setOpenSettings] = useState(false);
    const [openGiveCoffee, setOpenGiveCofee] = useState(false);
    const { isDarkMode, isNewPacoca } = useTheme();
    const [isAtTop, setIsAtTop] = useState(false);
    const firstRun = useRef(true);
    const [loadingImg, setLoadingImg] = useState(false);
    const firstLoad = useRef<boolean>(true);
    const firstLoadPost = useRef<boolean>(true);
    const [imgSrc, setImgSrc] = useState<string>("");
    const [imgBannerSrc, setImgBannerSrc] = useState<string>("");
    const [openCropBanner, setOpenCropBanner] = useState(false);
    const [loadingCropBanner, setLoadingCropBanner] = useState(false);
    const openModalRef = useRef<HTMLButtonElement | null>(null);
    const closeModalRef = useRef<HTMLButtonElement | null>(null);
    const openModalBannerRef = useRef<HTMLButtonElement | null>(null);
    const closeModalBannerRef = useRef<HTMLButtonElement | null>(null);
    const inputRef = useRef<HTMLInputElement | null>(null);
    const [isOpenModalProfile, setIsOpenModalProfile] = useState(false);
    const statusbarStyleClose = useMemo(() => (window.location.pathname === "/" ||(window.location.pathname.includes("@") && !window.location.pathname.includes("chat"))) && isAtTop ? (isDarkMode ? "#181818" : "#F4F2EE") : (isDarkMode ? "#000" : "#fff"), [isAtTop, window.ReactNativeWebView, window.ReactNativeWebView?.postMessage, window.innerWidth, window.location.pathname, isDarkMode]);
    const [errorsInput, setErrorsInput] = useState<{ newPasswordConfirmation?: string[]; password?: string[]; old_password?: string[]; image?: string[]; email?: string[]; name?: string[]; user_name?: string[]; phone?: string[]; site?: string[]; biography?: string[]; sexo?: string[]; birth_date?: string[]; }>({});
    
    const extractPlaylistId = (input: string) => {
        if (input.includes("list=")) {
            const match = input.match(/[?&]list=([^&]+)/);
            return match ? match[1] : null;
        }

        return input; // assume que já é o ID
    };

    const handleAddPlaylist = async () => {
        const playlistId = extractPlaylistId(playlistUrl);

        if (!playlistId) {
            setMessage("Link inválido", "error");
            return;
        }

        setLoadingAddPlaylist(true);

        try {
            const response = await api(token).post("/playlists", {
                playlist_id: playlistId
            });

            setMessage("Playlist adicionada!", "success");
            setPlaylistUrl("");

            setPlaylists(prev => [response.data, ...prev]);

        } catch (err: any) {
            const messageError = errorMessage(err);
            setMessage(messageError, "error");
        } finally {
            setLoadingAddPlaylist(false);
        }
    };

    const handleOpenPlaylist = async (playlist: any) => {
        setSelectedPlaylist(playlist);
        setLoadingVideos(true);

        try {
            const response = await api(token).get(`/playlists/videos/${playlist.playlist_id}`);

            console.log("videos", response.data);
            
            setVideos(response.data);

        } catch (err) {
            console.error(err);
            setMessage("Erro ao carregar músicas", "error");
        } finally {
            setLoadingVideos(false);
        }
    };

    useEffect(() => {
            setIsAtTop(true);
            const handleScroll = () => {
                setIsAtTop(window.scrollY < 120); // considera "no topo" se scroll for menor que 10px
            };
    
            window.addEventListener("scroll", handleScroll);
            return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    
    useEffect(() => {
        document?.querySelector("body")?.classList.add("main-profile");
        return () => document?.querySelector("body")?.classList.remove("main-profile");
    }, []);

    const copyLinkUser = () => {
        const encodedUserName = encodeURIComponent(userName?.trim() ?? "");
        const link = `${window.location.origin}/@${encodedUserName}`;
        
        if (navigator.share) {
            navigator.share({
                title: `Compartilhar @${userName}`,
                url: link,
            }).catch((error) => console.error('Erro ao compartilhar o link:', error));
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(link)
                .then(() => setMessage("Link copiado", "success"))
                .catch((error) => console.error('Erro ao copiar o link:', error));
        } else {
            alert('Copie este link: ' + link);
        }
    };

    useEffect(() => {
        setPosts([])
        setPoems([])
        setPhotos([])
        setPlaylists([])
        setSelectedPlaylist(null)
        setVideos([])
        // Use optimistic user data from router state so the profile renders immediately;
        // loadData() will fetch fresh data in the background.
        const optimisticUser = (location.state as { user?: User } | null)?.user ?? null;
        setUser(optimisticUser)
        setLoading(!optimisticUser)
        setNotFound(false)
        setErrorLoad(false)
        setCommunities([])
        setMembers([])
        setFollowings([])
        setStatusCommunities(StatusString.loading)
        setStatusFollowing(StatusString.loading)
        setStatusMembers(StatusString.loading)
        // setPage(1)
        // loadPosts(1)
        firstRun.current = true;
        firstLoad.current = true;
        firstLoadPost.current = true;
    }, [location.pathname, userName])

    const updateImage = async (fileParam?: File | null) => {
        let file: File | null = null;
        // if (loadingImg) return;
        setLoadingImg(true)
        setErrorsInput({});
        // Envia a imagem para o backend
        try {
            if (fileParam) {

            file = fileParam
            file = await convertHeic(file);
            file = await compressImage(file);
            } else {
            const inputFile = document.getElementById("image") as HTMLInputElement;
            if (!inputFile?.files?.length) {
                throw {
                response: { data: { errors: { image: ["Selecione uma imagem."] } } }
                };
            }
            file = inputFile.files[0];
            }

            if (!file) return;
            const formData = new FormData();

            const uploadPayload = [
                { type: "image" }
            ];

            const { data: uploadUrls } = await axios.post(PACOCA_API_URL + "/generate-upload-urls",{ files: uploadPayload }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            await uploadToSignedUrl(axios, uploadUrls[0].url, file);

            formData.append("image_path", uploadUrls[0].path);
           
            const response = await axios.post(`${PACOCA_API_URL}/account/update/photo`, formData, {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            setUser(prev => prev && { ...prev, img_account: response.data.img_account });
            setUserAuthenticated(prev => prev && { ...prev, img_account: response.data.img_account });

            setMessage(response.data.message, "success");
        } catch (err: any) {
            console.error(err);
            if (err?.response?.data.errors) {
                setErrorsInput(err.response.data.errors); // Atualiza o estado com os erros
            } else {
                const messageError = errorMessage(err)
                setMessage(messageError, "error")
                console.error(err);
                console.error(messageError);
            }
        } finally {
            setLoadingImg(false)
            closeModal();
        }
    };
    

    const updateBannerImage = async (fileParam?: File | null) => {
        let file: File | null = null;
        // if (loadingImg) return;
        setLoadingCropBanner(true)
        setErrorsInput({});
        // Envia a imagem para o backend
        try {
            if (fileParam) {

            file = fileParam
            file = await convertHeic(file);
            file = await compressImage(file);
            } else {
            const inputFile = document.getElementById("image") as HTMLInputElement;
            if (!inputFile?.files?.length) {
                throw {
                response: { data: { errors: { image: ["Selecione uma imagem."] } } }
                };
            }
            file = inputFile.files[0];
            }

            if (!file) return;
            const formData = new FormData();
            const uploadPayload = [
                { type: "image" }
            ];

            const { data: uploadUrls } = await axios.post(PACOCA_API_URL + "/generate-upload-urls",{ files: uploadPayload }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            await uploadToSignedUrl(axios, uploadUrls[0].url, file);

            formData.append("image_path", uploadUrls[0].path);

            const response = await axios.post(`${PACOCA_API_URL}/account/update/banner`, formData, {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            setUser(prev => prev && { ...prev, img_banner: response.data.img_banner });
            setUserAuthenticated(prev => prev && { ...prev, img_banner: response.data.img_banner });

            setMessage(response.data.message, "success");
        } catch (err: any) {
            console.error(err);
            if (err?.response?.data.errors) {
                setErrorsInput(err.response.data.errors); // Atualiza o estado com os erros
            } else {
                const messageError = errorMessage(err)
                setMessage(messageError, "error")
                console.error(err);
                console.error(messageError);
            }
        } finally {
            setLoadingCropBanner(false)
            setIsOpenBanner(false)
        }
    };

    // const handleClickImage = () => {
    //     if(user?.id != userAuthenticated?.id || removeToNativeiOS(userAuthenticated?.id)){
    //         // openImgRef.current?.click()
    //         // setImgPath(userImg);
    //         openImage === -1 ? setOpenImage(null) : setOpenImage(-1)
    //         return;
    //     }

    //     inputRef.current?.click();
    // }
    const handleClickImage = () => {
        // Perfil de outro usuário → dropdown com opções
        if (!removeToNativeiOS(userAuthenticated?.id)) {
            setOpenProfileOptions(prev => !prev);
            return;
        }
    };

    const closeModal = () => {
        setIsOpenProfile(false)
    }

    const onSelectFile = async(e: React.ChangeEvent<HTMLInputElement>) => {
        let file = e.target.files?.[0];
        if (!file) return;
        file = await convertHeic(file);
        file = await compressImage(file);
    
        const reader = new FileReader();
        reader.addEventListener("load", async() => {
            const imageElement = new Image();
            const imageUrl = reader.result?.toString() || "";
            imageElement.src = imageUrl;
            setImgSrc(imageUrl);
    
            // Verifique se o arquivo é um GIF
            if (file.type === "image/gif") {
            // Defina a imagem diretamente no preview
            setImgSrc(imageUrl);
            setIsOpenProfile(true)
            await updateImage();
            return; // Impede a execução posterior se for um GIF
            }
    
            imageElement.addEventListener("load", (event) => {
            if (error) setError("");
            const target = event.currentTarget as HTMLImageElement;
    
            const { naturalWidth, naturalHeight } = target;
    
            if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
                setError("A imagem precisa ter 150 x 150 pixels.");
                return setImgSrc("");
            }
            setIsOpenProfile(true)
            });
        });
        reader.readAsDataURL(file);
    };
    
    useEffect(() => {
        if(!path.includes("@") || path.includes("chat")) return;
        if (firstRun.current) {
            firstRun.current = false; // ignora a primeira execução
            return;
        }

        if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function') {
            if(user?.img_banner && openImage === null){
                window.ReactNativeWebView.postMessage(JSON.stringify({ statusBarStyle: "transparent" }));
                return;
            }

            window.ReactNativeWebView.postMessage(
                JSON.stringify({
                    statusBarStyle: openImage != null ? "#000" : statusbarStyleClose,
                })
            );
        }
    }, [openImage, path]);

    useEffect(() => {
        const handleModalClose = () => {
            setShowModalLikes(false)
            setShowModalComments(false)
            setIdPostSelected(null)
        };
    
        const modalLikesElement = document.getElementById("modal-likes");
        const modalCommentsElement = document.getElementById("modal-comments");

        if (modalLikesElement) 
            modalLikesElement.addEventListener("hidden.bs.modal", handleModalClose);

        if (modalCommentsElement) 
            modalCommentsElement.addEventListener("hidden.bs.modal", handleModalClose);
    
        return () => {
            if (modalLikesElement)
                modalLikesElement.removeEventListener("hidden.bs.modal", handleModalClose);

            if (modalCommentsElement)
                modalCommentsElement.removeEventListener("hidden.bs.modal", handleModalClose);
        };
    }, []);

    useEffect(() => {
        const path = window.location.pathname;
        const match = path.match(/^\/@(.+)/);
        if (match) {
            setUserName(match[1]);
        } else {
            setIsNotFoundPage(true);
            // navigate("*");
            return;
        }
    }, [navigate]);

    useEffect(() => {
        if(!path.includes("@") || path.includes("chat")) return;

        if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function') {
            if(user?.img_banner){
                window.ReactNativeWebView.postMessage(JSON.stringify({ statusBarStyle: "transparent" }));
                return;
            }
            window.ReactNativeWebView.postMessage(JSON.stringify({ statusBarStyle: isDarkMode ? "#000" : "#fff" }));
        }
    }, [isAtTop, user,  window.ReactNativeWebView, window.ReactNativeWebView?.postMessage, path, isDarkMode]);
    
    useEffect(() => {
        if(openImage != null && openImage >= 0)
            document.body.style.overflow = "hidden"
        else
            document.body.style.overflow = "auto"
    }, [window.location.href, openImage]);

    const loadPoems = async (cursorParam: number | null = cursorPoem) => {
        if(!user) return;
        let url = `${PACOCA_API_URL}/posts?id_user=${user?.id}&hide_posts_community=${1}&hide_ads=${1}&poems=true`;

        if(cursorParam){
            url += `&cursor=${cursorParam}`;
        }

        if (isLoadingPosts || end) return;
        setLoadingPosts(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data.posts;
            setCursorPoem(response.data.next_cursor);
            
            if (data.length > 0) {
                setPoems((prev) => {
                    const existingIds = new Set(prev.map(post => post?.id)); // Cria um Set com os IDs existentes
                    const newPosts = data.filter((post: { id: any; }) => !existingIds.has(post?.id)); // Filtra apenas posts novos

                    if (newPosts.length === 0) return prev; // Se não houver novos posts, mantém o estado atual

                    const updatedPosts = [...prev, ...newPosts];

                    // Salva os posts no sessionStorage
                    sessionStorage.setItem('poems', JSON.stringify(updatedPosts));

                    return updatedPosts;
                });
            } else {
                setEnd(true);
            }

        } catch (err: any) {
            console.error("Failed to load posts:", err);
            if (err.status == 401) setError(t("generics.errors.sessionExpired"));
            setEnd(true);
            if (err.status == 429)
                setError(t("generics.errors.tooManyRequestsGeneric"))
        } finally {
            firstLoadPost.current = false;
            setLoadingPosts(false);
        }
    };

    type PostFiltersOverride = { keyword?: string; oldestFirst?: boolean; hasLink?: boolean; mediaType?: "" | "photos" | "videos" };

    const loadPosts = async (cursorParam: number | null = cursor, filtersOverride?: PostFiltersOverride) => {
        if(!user) return;
        let url = `${PACOCA_API_URL}/posts?id_user=${user?.id}&hide_posts_community=${1}&hide_ads=${1}&return_fixed_post=${cursorParam == null}`;

        if(cursorParam){
            url += `&cursor=${cursorParam}`;
        }

        const kw        = filtersOverride !== undefined ? filtersOverride.keyword       ?? "" : filterKeyword;
        const oldest    = filtersOverride !== undefined ? filtersOverride.oldestFirst   ?? false : filterOldestFirst;
        const hasLnk    = filtersOverride !== undefined ? filtersOverride.hasLink       ?? false : filterHasLink;
        const mediaT    = filtersOverride !== undefined ? filtersOverride.mediaType     ?? "" : filterMediaType;

        if (kw)      url += `&keyword=${encodeURIComponent(kw)}`;
        if (oldest)  url += `&oldest_first=1`;
        if (hasLnk)  url += `&has_link=1`;
        if (mediaT)  url += `&mediaType=${mediaT}`;

        if (isLoadingPosts || end) return;
        setLoadingPosts(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data.posts;
            setCursor(response.data.next_cursor);
            
            if (data.length > 0) {
                setPosts((prev) => {
                    const existingIds = new Set(prev.map(post => post?.id)); // Cria um Set com os IDs existentes
                    const newPosts = data.filter((post: { id: any; }) => !existingIds.has(post?.id)); // Filtra apenas posts novos

                    if (newPosts.length === 0) return prev; // Se não houver novos posts, mantém o estado atual

                    const updatedPosts = [...prev, ...newPosts];

                    // Salva os posts no sessionStorage
                    sessionStorage.setItem('posts', JSON.stringify(updatedPosts));

                    return updatedPosts;
                });
            } else {
                setEnd(true);
            }

        } catch (err: any) {
            console.error("Failed to load posts:", err);
            if (err.status == 401) setError(t("generics.errors.sessionExpired"));
            setEnd(true);
            if (err.status == 429)
                setError(t("generics.errors.tooManyRequestsGeneric"))
        } finally {
            firstLoadPost.current = false;
            setLoadingPosts(false);
        }
    };

    const loadWatchedMedia = async () => {
        if (loadingWatchedMedia || !user?.id) return;
        setLoadingWatchedMedia(true);
        try {
            const response = await api(token).get(`/watched-media/by-user-id/${user.id}`);
            setWatchedMedia(response.data.items ?? []);
        } catch (err: any) {
            setMessage(errorMessage(err), "error");
        } finally {
            setLoadingWatchedMedia(false);
        }
    };

    const searchWatchedMedia = async (q: string) => {
        if (!q.trim()) { setWatchedMediaResults([]); return; }
        setLoadingWatchedSearch(true);
        try {
            const response = await api(token).get('/watched-media/search', { params: { q, type: 'multi' } });
            setWatchedMediaResults(response.data.results ?? []);
        } catch (err: any) {
            setMessage(errorMessage(err), "error");
        } finally {
            setLoadingWatchedSearch(false);
        }
    };

    const addWatchedMedia = async (result: TmdbSearchResult, status: WatchedMedia['status']) => {
        setAddingWatchedMedia(result.tmdb_id);
        try {
            const response = await api(token).post('/watched-media', {
                tmdb_id: result.tmdb_id,
                media_type: result.media_type,
                status,
            });
            setWatchedMedia(prev => {
                const exists = prev.find(m => m.tmdb_id === result.tmdb_id && m.media_type === result.media_type);
                if (exists) return prev.map(m => m.id === exists.id ? response.data.item : m);
                return [response.data.item, ...prev];
            });
            setWatchedMediaResults([]);
            setWatchedMediaSearch('');
            setMessage('Adicionado com sucesso!', 'success');
        } catch (err: any) {
            setMessage(errorMessage(err), "error");
        } finally {
            setAddingWatchedMedia(null);
        }
    };

    const removeWatchedMedia = async (item: WatchedMedia) => {
        setRemovingWatchedMedia(item.id);
        try {
            await api(token).delete(`/watched-media/${item.id}`);
            setWatchedMedia(prev => prev.filter(m => m.id !== item.id));
        } catch (err: any) {
            setMessage(errorMessage(err), "error");
        } finally {
            setRemovingWatchedMedia(null);
        }
    };

    useEffect(() => {
        const root = document.getElementById("root");
        if (root) root.style.overflowX = "hidden";

        return () => {
            if (root) root.style.overflow = "";
        };
    }, []);

    useEffect(() => {
        if (user?.id && contentAccount == "all") loadPosts(cursor);
        sessionStorage.setItem('page', page.toString());
    }, [page, user?.id]);

    useEffect(() => {
        if (user?.id && contentAccount == "poems") loadPoems(cursorPoem);
        sessionStorage.setItem('pagePoem', pagePoem.toString());
    }, [pagePoem, user?.id]);

    useEffect(() => {
        sessionStorage.setItem('photosPage', pageImage.toString());
    }, [pageImage]);

    useEffect(() => {
        if (user?.id && contentAccount == "musics") loadPlaylists();
    }, [user?.id]);

    useEffect(() => {
        if (user?.id && contentAccount == "filmes") loadWatchedMedia();
    }, [user?.id, contentAccount]);

    const observerCallback = useCallback(
        (entries: IntersectionObserverEntry[]) => {
            const target = entries[0];
            if (target.isIntersecting) {
                if (contentAccount == "all" && !isLoadingPosts && !end && user?.id) setPage((prev) => prev + 1);
                if (contentAccount == "poems" && !isLoadingPosts && !end && user?.id) setPagePoem((prev) => prev + 1);
                if (contentAccount == "photos" && !isLoadingImages && !endPhotos) setPageImage((prev) => prev + 1);
            }
        },
        [isLoadingPosts, end, isLoadingImages, endPhotos]
    );

    useEffect(() => {
        if (endOfListRef.current) {
            observerRef.current = new IntersectionObserver(observerCallback, {
                root: null,
                rootMargin: "200px",
                threshold: 0.1
            });

            observerRef.current.observe(endOfListRef.current);
        }

        return () => observerRef.current?.disconnect();
    }, [observerCallback]);

    const handleFollowUser = async () => {
        const originalTotalFollowers = user?.total_followers ?? 0;
        const newFollowing = !isFollowing;
        const url = PACOCA_API_URL + "/users/" + (newFollowing ? "follow" : "unfollow") + "/" + user?.id;
        const newTotalFollowers = newFollowing ? (user?.total_followers ?? 0) + 1 : Math.max((user?.total_followers ?? 0) - 1, 0);

        setIsFollowing(newFollowing);
        setUser(prevUser => prevUser ? { ...prevUser, total_followers: newTotalFollowers } : prevUser);

        try {
            await axios.post(url, null, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            })

        } catch (err: any) {
            const newisFollowing = isFollowing;
            setIsFollowing(newisFollowing);
            setUser(prevUser => prevUser ? { ...prevUser, total_followers: originalTotalFollowers } : prevUser);
            const messageError = errorMessage(err)
            const reason = err?.response?.data.reason && err?.response?.status == 403 ? err?.response?.data.reason : null;
            setMessage(messageError || "Erro ao enviar o aviso.", "error", undefined, undefined, reason);
            console.error('Erro:', err);
        }
    }

    const loadData = async () => {
        const url = PACOCA_API_URL + `/users/` + userName;

        // Only show the skeleton loader when we don't already have user data to display.
        if (!user) setLoading(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;
            setPosts([])
            setPoems([])
            setPhotos([])
    
            if (data.user) { // Verifique se data.user é um objeto
                setUser(data.user);
                setIsFollowing(data.user?.is_following)
                setIsFollowed(data.user?.is_followed)
                setIsBanned(data.user?.is_banned)
                if(data.user?.is_visible === false){
                    setLoadingPosts(false);
                    firstLoadPost.current = false;
                }
            }
        } catch (err: any) {
            if (err.status == 404) {
                setNotFound(true)
                return
            }
            setErrorLoad(true);
            const messageError = errorMessage(err)
            setMessage(messageError, "error")
            console.error('Erro:', err);
            setLoadingPosts(false);
            firstLoadPost.current = false;
        } finally {
            firstLoad.current = false;
            setLoading(false);
        }
    };

    const loadPlaylists = async () => {
        if (loadingPlaylists || !user?.id) return;

        setLoadingPlaylists(true);

        try {
            const response = await api(token).get(`/playlists/${user.id}`);

            const data = response.data;

            if (data) {
                setPlaylists(data);
            }

        } catch (err: any) {
            const messageError = errorMessage(err);
            setMessage(messageError, "error");

            console.error('Erro:', err);
        } finally {
            setLoadingPlaylists(false);
        }
    };

    const loadImages = async (page: number) => {
        const url = PACOCA_API_URL + `/users/images/${userName}?page=${pageImage}&limit=${limitImage}`;

        if (isLoadingImages || endPhotos) return;
        setLoadingImages(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (data.photos && data.photos.length) {
                setPhotos((prev) => {
                    const existingIds = new Set(prev.map(photo => photo.id)); // Cria um Set com os IDs existentes
                    const newPosts = data.photos.filter((photo: { id: any; }) => !existingIds.has(photo.id)); // Filtra apenas posts novos

                    if (newPosts.length === 0) return prev; // Se não houver novos posts, mantém o estado atual

                    const updatedPosts = [...prev, ...newPosts];

                    // Salva os posts no sessionStorage
                    sessionStorage.setItem('photos', JSON.stringify(updatedPosts));

                    return updatedPosts;
                });

                if (data.posts) {
                    setPhotoPosts(prev => {
                        const existingIds = new Set(prev.map(p => p.id));
                        const newPosts = data.posts.filter((p: Post) => !existingIds.has(p.id));
                        return [...prev, ...newPosts];
                    });
                }
            } else {
                setEndPhotos(true)
            }

        } catch (err: any) {
            setLoadingImages(false);
            setEndPhotos(true)
            const messageError = errorMessage(err)
            // setMessage(messageError, "error")
            console.error('Erro:', err);
            console.error('Erro:', messageError);
        } finally {
            setLoadingImages(false);
        }
    }

    const [termo, setTermo] = useState("");
    const [debouncedTermo, setDebouncedTermo] = useState("");

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setTermo(inputValue); // atualiza imediatamente o campo
        debouncedHandleInput(inputValue); // dispara o debounce
    };

    const debouncedHandleInput = useCallback(debounce((value: string) => { setDebouncedTermo(value); }, 500), []);
    useEffect(() => {
        loadFollowers(1);
    }, [debouncedTermo]);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            loadFollowers(1)
        }
    };

    const loadFollowers = async (page: number) => {
        if(!user?.id){
            // setStatusMembers(StatusString.success);
            return;
        }
        const url = `${PACOCA_API_URL}/users/followers/${user?.id}?page=${page}&followersType=all&search=${termo}`;
        setMembers([]);
        if(window.innerWidth <= 850) return;
        setStatusMembers(StatusString.loading);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (data.followers.length > 0) {
                setMembers((prev) => {
                    const existingIds = new Set(prev.map(community => community?.id)); // Cria um Set com os IDs existentes
                    const newCommunity = data.followers.filter((community: { id: any; }) => !existingIds.has(community?.id)); // Filtra apenas posts novos
            
                    if (newCommunity.length === 0) return prev; // Se não houver novos posts, mantém o estado atual
            
                    const updatedPosts = [...prev, ...newCommunity];
            
                    return updatedPosts;
                });
            }
            setStatusMembers(StatusString.success);
            
        } catch (err: any) {
            console.error("followers", error);
            setStatusMembers(StatusString.error);
        }
    };


    const [termo2, setTermo2] = useState("");
    const [debouncedTermo2, setDebouncedTermo2] = useState("");

    const handleChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setTermo2(inputValue); // atualiza imediatamente o campo
        debouncedHandleInput2(inputValue); // dispara o debounce
    };

    const debouncedHandleInput2 = useCallback(debounce((value: string) => { setDebouncedTermo2(value); }, 500), []);
    useEffect(() => {
        loadFollowing(1);
    }, [debouncedTermo2]);

    const handleKeyDown2 = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            loadFollowing(1)
        }
    };
    const loadFollowing = async (page: number) => {
        if(!user?.id){
            // setStatusFollowing(StatusString.success);
            return;
        }
        const url = `${PACOCA_API_URL}/users/following/${user?.id}?page=${page}&followingType=all&search=${termo2}`;
        setFollowings([]);
        if(window.innerWidth <= 850) return;
        setStatusFollowing(StatusString.loading);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (data.following.length > 0) {
                setFollowings((prev) => {
                    const existingIds = new Set(prev.map(community => community?.id)); // Cria um Set com os IDs existentes
                    const newCommunity = data.following.filter((community: { id: any; }) => !existingIds.has(community?.id)); // Filtra apenas posts novos
            
                    if (newCommunity.length === 0) return prev; // Se não houver novos posts, mantém o estado atual
            
                    const updatedPosts = [...prev, ...newCommunity];
            
                    return updatedPosts;
                });
            }
            setStatusFollowing(StatusString.success);
            
        } catch (err: any) {
            console.error("following", error);
            setStatusFollowing(StatusString.error);
        }
    };

    const [termo3, setTermo3] = useState("");
    const [debouncedTermo3, setDebouncedTermo3] = useState("");

    const handleChange3 = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setTermo3(inputValue); // atualiza imediatamente o campo
        debouncedHandleInput3(inputValue); // dispara o debounce
    };

    const debouncedHandleInput3 = useCallback(debounce((value: string) => { setDebouncedTermo3(value); }, 500), []);
    useEffect(() => {
        loadCommunities(1);
    }, [debouncedTermo3]);

    const handleKeyDown3 = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            loadCommunities(1)
        }
    };
    const loadCommunities = async (page: number) => {
            if(!user?.id) {
                // setStatusCommunities(StatusString.success);
                return
            }
            const url = `${PACOCA_API_URL}/communities/by-user/${user?.id}?page=${page}&followingType=all&search=${termo3}`;
            setCommunities([]);
            setStatusCommunities(StatusString.loading);
            // if(window.innerWidth <= 850) return;
    
            try {
                const response = await axios.get(url, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                });
    
                const data = response.data;
    
                if (data.communities.length > 0) {
                    setCommunities((prev) => {
                        const existingIds = new Set(prev.map(community => community?.id)); // Cria um Set com os IDs existentes
                        const newCommunity = data.communities.filter((community: { id: any; }) => !existingIds.has(community?.id)); // Filtra apenas posts novos
                
                        if (newCommunity.length === 0) return prev; // Se não houver novos posts, mantém o estado atual
                
                        const updatedPosts = [...prev, ...newCommunity];
                
                        return updatedPosts;
                    });
                }
                setStatusCommunities(StatusString.success);
                
            } catch (err: any) {
            console.error("communities", error);
                setStatusCommunities(StatusString.error);
            }
    };

    useEffect(() => {
        loadFollowers(1);
        loadFollowing(1);
        loadCommunities(1);
    }, [user?.id])

    useEffect(() => {
        if (userName) {
            loadData();
            loadImages(1);
        }
    }, [userName]);

    // useEffect(() => {
    //     if (userName) loadImages(page);
    // }, []);

    const getImagePath = (path: string) => {
        return BUCKET_PACOCA_URL + "/" + path;
    };

    const onClose = () => {
        setPassword("");
        setShowConfirmation(false);
        setShowConfirmationBanner(false);
        setErrorModalPassword("");
    }

    const handleChangecontentAccount = (type: EnumContent) => {
        if (user?.is_visible !== false)
            setContentAccount(type);
        setEnd(false);
        setEndPhotos(false);
        setCursor(null);
        setCursorPoem(null);
        setPage(1); // Mude para 1 para a primeira página
        setPagePoem(1);
        setPageImage(1); // Mude para 1 para a primeira página
        sessionStorage.removeItem('posts'); // Limpa os posts do sessionStorage
        sessionStorage.removeItem('photos'); // Limpa os posts do sessionStorage
        sessionStorage.removeItem('poems'); // Limpa os poemas do sessionStorage
        
        if (type == "all")
            loadPosts(null)
        if (type == "poems")
            loadPoems(null)
        if (type == "photos")
            loadImages(1)
        if (type == "musics")
            loadPlaylists()
    }

    const applyPostFilters = (newFilters: PostFiltersOverride) => {
        setFilterKeyword(newFilters.keyword ?? "");
        setFilterKeywordInput(newFilters.keyword ?? "");
        setFilterOldestFirst(newFilters.oldestFirst ?? false);
        setFilterHasLink(newFilters.hasLink ?? false);
        setFilterMediaType(newFilters.mediaType ?? "");
        setPosts([]);
        setEnd(false);
        setCursor(null);
        setPage(1);
        sessionStorage.removeItem('posts');
        firstLoadPost.current = true;
        loadPosts(null, newFilters);
    };

    const clearPostFilters = () => applyPostFilters({});

    const hasActiveFilters = filterKeyword || filterOldestFirst || filterHasLink || filterMediaType;

    const openFilterPanel = () => {
        if (window.innerWidth <= 850) {
            setOpenPostFilters(true);
        } else {
            setFilterPanelRendered(true);
            requestAnimationFrame(() => setFilterPanelEntering(true));
        }
    };

    const closeFilterPanel = () => {
        if (window.innerWidth <= 850) {
            setOpenPostFilters(false);
        } else {
            setFilterPanelEntering(false);
            if (filterPanelRef.current) clearTimeout(filterPanelRef.current);
            filterPanelRef.current = setTimeout(() => setFilterPanelRendered(false), 240);
        }
    };

    const handleStoryDeleted = (storyId: number, userId: number) => {
        setUsersStoriesProfile(prev => {
        return prev
            .map(u =>
            u.user.id === userId
                ? { ...u, stories: u.stories.filter(s => s.id !== storyId) }
                : u
            )
            .filter(u => u.stories.length > 0); // remove usuário se ficar sem stories
        });
    };
    
    const confirmDeletePicture = async (password: string) => {
        setIsLoading(true)
        const url = `${PACOCA_API_URL}/users/photo/${user?.id}`;
        if (user?.id !== userAuthenticated?.id && !password) {
            setErrorModalPassword("Informe sua senha")
            setIsLoading(false)
            return;
        }

        try {
            await axios.delete(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                params: { id_user: user?.id, password }
            });

            setMessage("Foto removida", "success");
            setUser(prevUser => prevUser ? { ...prevUser, img_account: getImageUserNotFound(user?.name) } : prevUser);
        } catch (err: any) {
            const messageError = errorMessage(err);
            setMessage(messageError, "error");
            console.error("Erro apagar foto de perfil: ", messageError);
            console.error("Erro apagar foto de perfil: ", err);
        } finally {
            setPassword("");
            setIsLoading(false);
            setShowConfirmation(false);
            setErrorModalPassword("");
        }
    };

    const confirmDeleteBanner = async (password: string) => {
        setIsLoading(true)
        const url = `${PACOCA_API_URL}/users/banner/${user?.id}`;
        if (user?.id !== userAuthenticated?.id && !password) {
            setErrorModalPassword("Informe sua senha")
            setIsLoading(false)
            return;
        }

        try {
            await axios.delete(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                params: { id_user: user?.id, password }
            });

            setMessage("Capa removida", "success");
            setUser(prevUser => prevUser ? { ...prevUser, img_banner: undefined } : prevUser);
        } catch (err: any) {
            const messageError = errorMessage(err);
            setMessage(messageError, "error");
            console.error("Erro apagar capa de perfil: ", messageError);
            console.error("Erro apagar capa de perfil: ", err);
        } finally {
            setPassword("");
            setIsLoading(false)
            setShowConfirmationBanner(false);
            setErrorModalPassword("");
        }
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [location.pathname]);

    const confirmDeleteAccount = async (password: string) => {
        setIsLoading(true)
        const url = `${PACOCA_API_URL}/users`;
        if (!password) {
            setErrorModalRemoveAccountPassword("Informe sua senha")
            setIsLoading(false)
            return;
        }

        try {
            await axios.delete(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                params: { id_user: user?.id, password }
            });

            setMessage("Conta excluida", "success");
            setPassword("");
            setShowConfirmationRemoveAccount(false)
            if (user?.id == userAuthenticated?.id) {
                setShowConfirmation(false)
                setShowConfirmationRemoveAccount(false)
                setTimeout(() => {
                    logout()
                }, 500)
            }

        } catch (err: any) {
            // if (err?.response?.data.errors) {
            //     setErrorModalRemoveAccountPassword(err.response.data.errors); // Atualiza o estado com os erros
            // } if (err?.response?.data.error) {
            //     setErrorModalRemoveAccountPassword(err.response.data.error); // Atualiza o estado com os erros
            // } else {
            const messageError = errorMessage(err);
            setErrorModalRemoveAccountPassword(messageError);
            console.error("Erro apagar conta: ", messageError);
            console.error("Erro apagar conta: ", err);
            // }
        } finally {
            setIsLoading(false)
        }
    };

    const handleDeletePicture = () => {
        setPassword("");
        setShowConfirmation(true);
    }

    const handleDeleteBanner = () => {
        setPassword("");
        setShowConfirmationBanner(true);
    }

    const handleDeleteAccount = () => {
        setPassword("");
        setShowConfirmationRemoveAccount(true);
    }

    const onUpdateReportStatus = () => {
        if(user){
            const updatedUser = user;
            updatedUser.reported = true
            setUser(updatedUser);
        }
    }

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;

        const checkOnline = async () => {
            try {
                if(!user?.id) return;
                const res = await api(token).get(`/users/online/${user?.id}`);
                if(res.data.online == user?.is_online) return;

                setUser(prev => {
                    if (!prev) return prev;

                    return {
                        ...prev,
                        is_online: res.data.online
                    };
                });
               setPosts(prev => {
                    if (!prev) return prev;

                    return prev.map(post => {
                        if (post.user.id === res.data.user_id) {
                            return {
                                ...post,
                                user: {
                                    ...post.user,
                                    is_online: res.data.online
                                }
                            };
                        }

                        return post;
                    });
                });
            } catch (e) {
                console.error(e);
            }
        };

        const start = () => {
            checkOnline();
            interval = setInterval(checkOnline, 15000);
        };

        const stop = () => {
            if (interval) clearInterval(interval);
            interval = null;
        };

        const handleVisibility = () => {
            if (document.visibilityState === "visible") {
                start();
            } else {
                stop();
            }
        };

        handleVisibility(); // roda na primeira vez
        document.addEventListener("visibilitychange", handleVisibility);

        return () => {
            stop();
            document.removeEventListener("visibilitychange", handleVisibility);
        };

    }, [user?.id]);

    if(isNotFoundPage) return <NotFound/>

    return (
        <>

            <ReportModal onUpdateReportStatus={onUpdateReportStatus} id_user={reportIdUser} id_post={reportIdPost} />
            <WarnUser onWarned={() => setIsWarned(true)} user={user} />
            <BanUser onBanned={() => setIsBanned(new Date())} user={user} reasonRequired={userAuthenticated?.id ? isSuper() : false} />
            <UnbanUser onBanned={() => setIsBanned(null)} user={user} reasonRequired={userAuthenticated?.id ? isSuper() : false} />
            <ConfirmationModal
                show={showConfirmation}
                onClose={() => onClose()}
                onConfirm={() => confirmDeletePicture(password)} // Passa a senha aqui
                title='Remover foto?'
                text='Tem certeza que deseja excluir a foto de perfil?'
                requirePassword={userAuthenticated?.id != user?.id}
                setPassword={setPassword} // Adicione a função setPassword aqui
                errorMessage={errorModal}
                isLoading={isLoading}
                coverMobile={false}
                closeRef={closeRef}
                idModal="remove-photo"
            />
            <ConfirmationModal
                show={showConfirmationBanner}
                onClose={() => onClose()}
                onConfirm={() => confirmDeleteBanner(password)} // Passa a senha aqui
                title='Remover capa?'
                text='Tem certeza que deseja excluir a capa do perfil?'
                requirePassword={userAuthenticated?.id != user?.id}
                setPassword={setPassword} // Adicione a função setPassword aqui
                errorMessage={errorModal}
                isLoading={isLoading}
                coverMobile={false}
                closeRef={closeRef}
                idModal="remove-banner"
            />
            <ConfirmationModal
                show={showConfirmationRemoveAccount}
                onClose={() => setShowConfirmationRemoveAccount(false)}
                onConfirm={() => confirmDeleteAccount(password)} // Passa a senha aqui
                title='Apagar conta?'
                text='O perfil e posts serão excluidos imediatamente e não é possível recuperar os dados. Esta ação é irreversível.'
                requirePassword={true}
                setPassword={setPassword} // Adicione a função setPassword aqui
                errorMessage={errorModalRemoveAccount}
                isLoading={isLoading}
                closeRef={closeRefDeleteAccount}
                idModal="delete-accounnt"
            />

            <ImageCropModal
                id="banner"
                type="banner"
                imageSrc={imgBannerSrc}
                loading={loadingCropBanner}
                isOpen={isOpenBanner}
                onClose={() => setIsOpenBanner(false)}
                onSave={(file) => { updateBannerImage(file) }}
            />

            <ImageCropModal
                id="profile"
                type="profile"
                imageSrc={imgSrc}
                loading={loadingImg}
                isOpen={isOpenProfile}
                onClose={() => setIsOpenProfile(false)}
                onSave={(file) => { updateImage(file) }}
            />

            {!notFound && !errorLoad && userAuthenticated ? (
                <>
                    {user && (
                        <Helmet>
                            <title>{user?.name} | Paçoca - Rede Social Brasileira</title>
                            <meta name="description" content={`${user?.biography ? user?.biography : `Veja o perfil de ${user?.name} na Paçoca, a rede social 100% brasileira para criar conexões e compartilhar momentos!`}`} />
                            <meta name="keywords" content={`Paçoca, rede social brasileira, amigos online, conexões digitais, comunidade digital, criar perfil, compartilhar momentos, seguir usuários, ${user?.name}, @${user?.user_name}, ${user?.biography || ''}`} />
                            <meta name="author" content="Paçoca Inc." />
                            <meta property="og:title" content={`${user?.name} | Paçoca - Rede Social`} />
                            <meta property="og:description" content={`${user?.biography ? user?.biography : `Veja o perfil de ${user?.name} na Paçoca, a rede social 100% brasileira para criar conexões e compartilhar momentos!`}`} />
                            <meta property="og:image" content="/img/link-preview.png?v=1" />
                            <meta property="og:url" content={window.location.href} />
                            <meta property="og:type" content="website" />
                            <meta name="twitter:card" content="summary_large_image" />
                            <meta name="twitter:title" content={`${user?.name} | Paçoca - Rede Social`} />
                            <meta name="twitter:description" content={`${user?.biography ? user?.biography : `Veja o perfil de ${user?.name} na Paçoca, a rede social 100% brasileira para criar conexões e compartilhar momentos!`}`} />
                            <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                            {/* Schema Markup */}
                            <script type="application/ld+json">{JSON.stringify(schemaMarkup)}</script>
                        </Helmet>
                    )}

                    {!isAtTop && isWebView() && user?.img_banner ? (
                        <div style={{ height: getNativeStatusBarHeight() ?? 20, position: "fixed", top: 0, right: 0, left: 0, zIndex: 9, background: isDarkMode ? "#000" : "#fff" }}/>
                    ): null}
                    
                    
                    <div className="container container-account" style={{ position: "relative" }}>
                        <LeftContent moreLeft hasDefault={false}>
                            <div className="card-left" style={{ borderRadius:"50%" }}>
                                <h5>{t("user.follow.followers")} {!user?.total_followers || user?.total_followers <=0 ? "" : `(${user?.total_followers})`}</h5>
                                <FollowersContent statusMembers={statusMembers} members={members} termo={termo} handleChange={handleChange} handleKeyDown={handleKeyDown} user={user}/>
                            </div>

                            <div className="card-left" style={{ borderRadius:"50%" }}>
                                <h5>{t("user.follow.userFollow")} {!user?.total_following || user?.total_following <=0 ? "" : `(${user?.total_following})`}</h5>
                                <FollowingContent statusMembers={statusFollowing} members={followings} termo={termo2} handleChange={handleChange2} handleKeyDown={handleKeyDown2} user={user}/>
                            </div>
                        </LeftContent>

                        <RightContent moreRight hasDefault={false}>
                            <div className="card-left" style={{ borderRadius:"50%" }}>
                                <h5>{t("community.pluralTitle")}</h5>
                                <CommunitiesContent statusMembers={statusCommunities} communities={communities} termo={termo3} handleChange={handleChange3} handleKeyDown={handleKeyDown3} user={user}/>
                            </div>
                            <SponsoredContent/>
                        </RightContent>
                        <div className="row" style={{ justifyContent: "center" }}>
                            <div className="row col-md-6" style={{ position: "relative" }}>
                                <img onError={ () => setUser(prev => prev ? { ...prev, img_banner: undefined } : null) } src={`${getImagePathBucketPacoca(user?.img_banner)}`} alt="" className="d-none" />

                                 {user?.img_banner && (
                                    <div className="banner-profile" style={{ backgroundImage: `linear-gradient(0deg, var(--background-post), transparent 50%), url("${getImagePathBucketPacoca(user?.img_banner)}")` }}/>
                                )}
                                <div className={`row bg-account bg-account-profile ${user?.img_banner ? "bg-account-profile-banner" : ""}`}>
                                    {/* <NavbarTop showMenuIcon={!Boolean(user?.active_frame?.image_path) || (Boolean(user?.active_frame?.image_path) && window.innerWidth <= 850)}> */}
                                    <NavbarTop >
                                    <div className="user-select-none" style={{ display: "flex", justifyContent: "center" }}>
                                        {user && (
                                            <>
                                            {/* none-pc */}
                                                <div className="dropdown dropdown-config-user">
                                                {/* <div className="dropdown dropdown-config-user" style={{ display: !user?.active_frame?.image_path  || (user?.active_frame?.image_path && window.innerWidth <= 850) ? "flex" : "none" }}> */}
                                                    <button className="icon-small-menu-top none-pc" onClick={() => setOpenSettings(true)} aria-label="Configuração do POST" style={{ border: 0, borderRadius: "5px", background: "transparent" }} type="button">
                                                        <Settings2 opacity={.6}/>
                                                    </button>
                                                    <button className="filter-invert-color none-cel" aria-label="Configuração do POST" style={{ border: 0, borderRadius: "5px", background: "transparent" }} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <Settings2 opacity={.6}/>
                                                    </button>

                                                    <ul className="dropdown-menu menu-drop">
                                                        <ShareProfile user_name={user?.user_name} />
                                                        <MuteUser id_user={user.id} is_muted={user.is_muted} />
                                                        <BlockUser is_blocked={user?.is_blocked} id_user={user?.id} />
                                                        <WarnUserDropdown user={user} isWarned={isWarned} />
                                                        <EditAccount user={user} />
                                                        <AddBanner onDelete={handleDeleteBanner} setImgSrc={setImgBannerSrc} setLoading={setLoadingCropBanner} setIsOpen={setIsOpenBanner} setError={setError} user={user}/>
                                                        <RemovePictureProfile can_remove_photo={user?.can_remove_photo} onDelete={handleDeletePicture} user={user} />
                                                        <RemoveAccount can_delete_account={user?.can_delete_account} onDelete={handleDeleteAccount} />
                                                        <Report alreadyReported={user?.reported} user={user} onReport={() => { setReportIdPost(null); setReportIdUser(user?.id) }} />
                                                        <PacocarUser id_user={user.id} name={user.name} can_pacocar={!!user.is_followed} />
                                                        <Transfer id_user={user?.id}/>
                                                        {contentAccount === "all" && (
                                                            <li>
                                                                <div className="dropdown-item cursor-pointer d-flex align-items-center gap-2" onClick={() => openFilterPanel()}>
                                                                    <SlidersHorizontal size={18} className={hasActiveFilters ? "text-pacoca-brown" : ""} />
                                                                    <span className={hasActiveFilters ? "text-pacoca-brown" : ""}>{t("account.filterPosts.title")}</span>
                                                                    {hasActiveFilters && <span className="badge-filter-active ms-auto"></span>}
                                                                </div>
                                                            </li>
                                                        )}
                                                    </ul>
                                                </div>

                                                <BottomSheet disableDrag snapPoints={[0, 0.5, 1]} initialSnap={1}  setOpen={setOpenSettings} open={openSettings}>
                                                    <div className="modal-dialog modal-dialog-likes modal-dialog-centered cover-mobile" role="document">
                                                        <div className="modal-content modal-content-likes" id="modal-content-likes">
                                                            <div className="modal-header modal-header-comments">
                                                                <h4 className={`modal-title ml-5`} id="modal-curtida"></h4>
                                        
                                                                {/* <button style={{ position: "absolute", right: 10, top: 10 }} data-bs-dismiss="modal" aria-label="Close" type="button" className="btn-close"></button> */}
                                                            </div>
                                                            <div className="modal-body modal-body-likes overflow-minus bottom-sheet-profile-settings"style={{ marginTop: 10, marginLeft: 5 }} onClick={() => setOpenSettings(false)}>
                                                                <ShareProfile user_name={user?.user_name} />
                                                                <MuteUser id_user={user.id} is_muted={user.is_muted} />
                                                                <BlockUser is_blocked={user?.is_blocked} id_user={user?.id} />
                                                                <WarnUserDropdown user={user} isWarned={isWarned} />
                                                                <EditAccount user={user} />
                                                                <AddBanner onDelete={handleDeleteBanner} setImgSrc={setImgBannerSrc} setLoading={setLoadingCropBanner} setIsOpen={setIsOpenBanner} setError={setError} user={user}/>
                                                                <RemovePictureProfile can_remove_photo={user?.can_remove_photo} onDelete={handleDeletePicture} user={user} />
                                                                <RemoveAccount can_delete_account={user?.can_delete_account} onDelete={handleDeleteAccount} />
                                                                <Report alreadyReported={user?.reported} user={user} onReport={() => { setReportIdPost(null); setReportIdUser(user?.id) }} />
                                                                <PacocarUser id_user={user.id} name={user.name} can_pacocar={!!user.is_followed} />
                                                                <Transfer id_user={user?.id} isMobile onClick={() => setOpenGiveCofee(true)}/>
                                                                {contentAccount === "all" && (
                                                                    <div className="dropdown-item cursor-pointer user-select-none" onClick={() => { setOpenSettings(false); openFilterPanel(); }}>
                                                                        <div className="div-icon-fix">
                                                                            <div className="div-icon-block">
                                                                                <SlidersHorizontal className={`icon-config-post ${hasActiveFilters ? "text-pacoca-brown" : ""}`} size={20} />
                                                                                <span className={hasActiveFilters ? "text-pacoca-brown" : ""}>{t("account.filterPosts.title")}</span>
                                                                                {hasActiveFilters && <span className="badge-filter-active ms-1"></span>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </BottomSheet>

                                            </>
                                        )}

                                        {/* {user?.can_edit_permissions && (!user?.active_frame?.image_path  || (user?.active_frame?.image_path && window.innerWidth <= 850)) ? ( */}
                                        {user?.can_edit_permissions ? (
                                            <div className="user-select-none" style={{ display: "flex", justifyContent: "center" }}>
                                                <div className="dropdown dropdown-config-user">
                                                    <button onClick={() => navigate(`/permissoes/${user?.id}`)} className="filter-invert-color" aria-label="Configuração do POST" style={{ border: 0, borderRadius: "5px", background: "transparent" }}>
                                                        <Settings opacity={.6}/>
                                                    </button>
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                </NavbarTop>
                               

                                    <div className="col-8 col-content-user col-name-user col-username-account" style={{ marginBottom: "10px!important", opacity: user?.is_banned ? .5 : 1 }}>
                                        <h2>
                                            {loading && <span className="placeholder placeholder-text placeholder-name-account"></span> }
                                            {user?.name}
                                            <ImgVerified user={user} classNameProp="user-select-none img-verificado-conta" />
                                        </h2>
                                        <p className="username-account" style={{ marginBottom: "0px" }}>
                                            {loading ? <span className="placeholder placeholder-text" style={{width: "100px"}}></span> : `@${user?.user_name}` }
                                        </p>

                                        {user?.is_visible !== false ? (
                                            <div style={{ width: "105%" }}>
                                                {user?.biography ? (
                                                    <p style={{marginTop: 0, marginBottom: 0}} className=" text-biography" dangerouslySetInnerHTML={{ __html: clearText(censorText(normalizeLineBreaks(user?.biography))) }} ></p>
                                                ) : null}
                                                {user?.site ? (
                                                    <p style={{marginTop: 0, marginBottom: 0}} className=""><a target="_BLANK" href={user?.site}>{user?.site.replace("https://", "").replace("http://", "")}</a></p>
                                                ) : null}
                                                </div>
                                        ) : null}
                                    </div>

                                    {/* Informações */}
                                    <div className="col-4 col-img-conta user-select-none" style={{ position: "relative", opacity: user?.is_banned ? .5 : 1 }}>
                                        {/* Substitua o bloco da foto de perfil */}
                                        <div style={{ position: "relative" }}>
                                            
                                            {/* DROPDOWN — só PC */}
                                            <div className="none-cel">
                                                <div className="dropdown dropdown-config-user none-cel">
                                                    <div data-bs-toggle="dropdown" aria-expanded="false" style={{ position: "relative", cursor: "pointer" }}>
                                                        {loading ? (
                                                            <span className="placeholder placeholder-circle placeholder-img-conta-perfil" style={{width: "150px", height: "150px", borderRadius: "50%"}}></span>
                                                        ) : (
                                                            <FreezeGif
                                                                alt="Foto de perfil"
                                                                className={`${openImage == -1 ? "img-conta-perfil-open" : ""} cursor-pointer img-conta-perfil`}
                                                                src={getImageUser(user?.img_account, undefined, user?.name)}
                                                                fallbackSrc={getImageUserNotFound(user?.name)}
                                                                shouldAnimate={canAnimateProfilePhoto(user?.stamps)}
                                                                onError={(e) => { e.currentTarget.src = getImageUserNotFound(user?.name); }}
                                                            />
                                                        )}
                                                        {user?.active_frame?.image_path && (
                                                            <Frame path={`${BUCKET_PACOCA_URL}/${user.active_frame?.image_path}`} className="cursor-pointer account" />
                                                        )}
                                                        {(user?.is_online || isEveryOnline(user?.id)) && (
                                                            <div className="active-user"></div>
                                                        )}
                                                    </div>

                                                    <ul className="dropdown-menu menu-drop">
                                                        {/* Ver foto */}
                                                        <li>
                                                            <div className="dropdown-item cursor-pointer d-flex align-items-center gap-2"
                                                                onClick={() => openImage === -1 ? setOpenImage(null) : setOpenImage(-1)}
                                                            >
                                                                <ImageIcon size={18} />
                                                                <span>{t("account.viewProfilePhoto")}</span>
                                                            </div>
                                                        </li>

                                                        {/* Ver stories */}
                                                        {user?.has_stories && (
                                                            <li>
                                                                <div className="dropdown-item cursor-pointer d-flex align-items-center gap-2"
                                                                    onClick={() => fetchAndOpenStory()}
                                                                >
                                                                    <PanelsTopLeft size={18} />
                                                                    <span>{t("account.viewStories")}</span>
                                                                </div>
                                                            </li>
                                                        )}

                                                        {/* Editar foto — só dono */}
                                                        {user?.id === userAuthenticated?.id && !removeToNativeiOS(userAuthenticated?.id) && (
                                                            <li>
                                                                <div className="dropdown-item cursor-pointer d-flex align-items-center gap-2"
                                                                    onClick={() => inputRef.current?.click()}
                                                                >
                                                                    <Pencil size={18} />
                                                                    <span>{t("account.changeProfilePhoto")}</span>
                                                                </div>
                                                            </li>
                                                        )}

                                                        {/* Remover moldura — só para o próprio usuário com moldura ativa */}
                                                        {(user?.can_remove_photo || user?.id === userAuthenticated?.id) && user?.active_frame && (
                                                            <div className="dropdown-item cursor-pointer user-select-none"
                                                                onClick={async () => {
                                                                    setOpenProfileOptions(false);
                                                                    try {
                                                                        await axios.post(`${PACOCA_API_URL}/frames/remove`, {}, {
                                                                            headers: { Authorization: `Bearer ${token}` }
                                                                        });
                                                                        setUserAuthenticated(prev => prev ? { ...prev, active_frame: undefined } : prev);
                                                                        setUser(prev => prev ? { ...prev, active_frame: undefined } : prev);
                                                                        setMessage(t("frames.frameRemoved"), "success");
                                                                    } catch (err) {
                                                                        setMessage(errorMessage(err), "error");
                                                                    }
                                                                }}
                                                            >
                                                                <div className="div-icon-fix">
                                                                    <div className="div-icon-block">
                                                                        <Trash2 className="icon-config-post" size={20} />
                                                                        <span>{t("frames.removeFrame")}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </ul>
                                                </div>
                                            </div>

                                            {/* ÍCONE DE EDITAR — só dono, só PC */}
                                            {user?.id == userAuthenticated?.id && !removeToNativeiOS(userAuthenticated?.id) ? (
                                                <div className="edit-image-profile none-cel">
                                                    <Pencil height={15} />
                                                </div>
                                            ) : null}

                                            {/* BOTTOMSHEET — só mobile */}
                                            <div className="none-pc" style={{ position: "relative" }} onClick={() => setOpenProfileOptions(true)}>
                                                {loading ? (
                                                    <span className="placeholder placeholder-circle placeholder-img-conta-perfil" style={{width: "80px", height: "80px", borderRadius: "50%"}}></span>
                                                ) : (
                                                    <FreezeGif
                                                        alt="Foto de perfil"
                                                        className={`${openImage == -1 ? "img-conta-perfil-open" : ""} cursor-pointer img-conta-perfil`}
                                                        src={getImageUser(user?.img_account, undefined, user?.name)}
                                                        fallbackSrc={getImageUserNotFound(user?.name)}
                                                        shouldAnimate={canAnimateProfilePhoto(user?.stamps)}
                                                        onError={(e) => { e.currentTarget.src = getImageUserNotFound(user?.name); }}
                                                    />
                                                )}
                                                {user?.active_frame?.image_path && (
                                                    <Frame path={`${BUCKET_PACOCA_URL}/${user.active_frame?.image_path}`} className="cursor-pointer account" />
                                                )}
                                                {(user?.is_online || isEveryOnline(user?.id)) && (
                                                    <div className="active-user"></div>
                                                )}

                                                {user?.id == userAuthenticated?.id && !removeToNativeiOS(userAuthenticated?.id) ? (
                                                    <div className="edit-image-profile">
                                                        <Pencil height={15} />
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>

                                    <input ref={inputRef} type="file" name="image" id="image" accept="image/*" onChange={onSelectFile} className="input-file-hidden" />

                                    <div style={{ height: user?.biography ? 10 : 30 }}></div>

                                    {user && user?.is_visible !== false ? (
                                        <div className="noane-cel" style={{marginTop: !user?.biography?.length && !user?.site?.length ? "20px" : "5px", opacity: user?.is_banned ? .5 : 1}}>
                                            <div className="seguidores-novo">
                                                <p>                                                    
                                                    <span className="cursor-pointer" onClick={() => handleChangecontentAccount("all")}>• {t("user.postsCount", { count: user?.total_posts })}</span>
                                                    {user?.total_poems != null && user?.total_poems > 0 && <span className="cursor-pointer" onClick={() => handleChangecontentAccount("poems")}>• {t("user.poemsCount", { count: user?.total_poems })}</span>}
                                                    {user?.total_articles != null && user?.total_articles > 1 && <span>• {t("user.articlesCount", { count: user?.total_articles })}</span>}
                                                    <span>• {t("user.commentsCount", { count: user?.total_comments })}</span>
                                                    <span className="cursor-pointer" onClick={() => navigate(`/seguidores/${user?.id}`)}>• {t("user.followersCount", { count: user?.total_followers })}</span>
                                                    <span className="cursor-pointer" onClick={() => navigate(`/seguindo/${user?.id}`)}>• {t("user.followingCount", { count: user?.total_following })}</span>
                                                </p>
                                            </div>
                                        </div>
                                    ) : null}
                                    
                                    {/* {user?.is_visible !== false ? (
                                        <div className="none-pc" style={{marginTop: !user?.biography?.length && !user?.site?.length ? "20px" : "5px"}}>
                                            <div className="seguidores">
                                                <div className="col-3 justify-content-center d-flex" style={{marginLeft: "-5px", marginRight: "-10px"}}>{formatNumber(user?.total_posts)}</div>
                                                <div className="col-3 justify-content-center d-flex" style={{marginRight: "10px"}}>{formatNumber(user?.total_comments)}</div>
                                                <div className="col-3 justify-content-center d-flex">{formatNumber(user?.total_followers)}</div>
                                                <div className="col-3 justify-content-center d-flex">{formatNumber(user?.total_following)}</div>

                                                <div className="col-3 justify-content-center d-flex" style={{marginLeft: "-5px", marginRight: "-10px"}}>{t("user.postsCount")}</div>
                                                <div className="col-3 justify-content-center d-flex" style={{marginRight: "10px"}}>{t("user.commentsCount")}</div>
                                                <div className="col-3 justify-content-center d-flex cursor-pointer" onClick={() => navigate(`/seguidores/${user?.id}`)}>{t("user.followersCount")}</div>
                                                <div className="col-3 justify-content-center d-flex cursor-pointer" onClick={() => navigate(`/seguindo/${user?.id}`)}>{t("user.followingCount")}</div>
                                            </div>
                                        </div>
                                    ) : null} */}

                                    <div className="col-12 col-name-user">
                                        <div className="d-flex row-button-account" style={{ width: "100%!important", flexWrap: "wrap", marginTop: !user?.biography?.length && !user?.site?.length && window.innerWidth >=850 ? "20px" : "5px" }}>
                                            {loading && (
                                                <>
                                                    <div className="none-cel col col-conversar col-button-account">
                                                        <span className={`btn ${isFollowing ? "btn-gray" : "btn-gray"} placeholder btn-sm btn-shadow`} style={{ width: "100%", marginRight: "5px" }}>
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <div className="none-cel col col-conversar col-button-account" style={{ marginLeft: "5px" }}>
                                                        <a className="btn placeholder btn-gray btn-sm" style={{ width: "100%", height: "100%" }}>
                                                            &nbsp;
                                                        </a> 
                                                    </div>
                                                </>
                                            )}

                                            {user && user?.is_visible !== false && user?.id != userAuthenticated.id && !user?.is_banned ? (
                                                <>
                                                    <div className="col col-conversar col-button-account">
                                                        <span onClick={handleFollowUser} className={`btn-w-100 btn ${isFollowing ? "btn-gray" : "btn-blue"} btn-sm btn-shadow`} style={{ width: "100%", marginRight: "5px" }}>
                                                            {isFollowing ? t("user.follow.following") : (isFollowed ? t("user.follow.followBack") : t("user.follow.follow"))}
                                                        </span>
                                                    </div>
                                                    <div onClick={() => navigate(`/chat/@${user?.user_name}?adicionar-principal=true`)} className="col col-conversar col-button-account" style={{ marginLeft: "5px" }}>
                                                        <a className="btn-w-100 btn btn-gray btn-sm" style={{ width: "100%", height: "100%" }}>
                                                            {t("user.chat")}
                                                        </a> 
                                                    </div>
                                                </>
                                            ) : null}

                                            {user?.id === userAuthenticated.id ? (
                                                <>
                                                    <div className="col col-conversar col-button-account">
                                                        <span onClick={() => navigate(`/conta`)} className={`btn-w-100 btn btn-gray btn-sm`} style={{ width: "100%", marginRight: "5px" }}>
                                                            {t("user.editAccount")}
                                                        </span>
                                                    </div>
                                                    <div onClick={copyLinkUser} className="col col-conversar col-button-account" style={{ marginLeft: "5px" }}>
                                                        <a className="btn-w-100 btn btn-gray btn-sm" style={{ width: "100%", height: "100%" }}>
                                                            {t("post.actions.shareProfile")}
                                                        </a> 
                                                    </div>
                                                </>
                                            ) : null}

                                            {/* {{-- opcoes (todos os usuarios tem) --}} */}
                                        </div>

                                        {/* banir e configurar usuários */}
                                        <div className="d-flex row-button-account" style={{ margin: 0, width: "100%!important", flexWrap: "wrap", marginTop: "10px" }}>
                                            {user?.can_ban_user ? (
                                                <>
                                                    {!isBanned ? (
                                                        <div className="col col-conversar col-button-account">
                                                            <span data-bs-toggle="modal" data-bs-target="#modal-ban" className={`btn-w-100 btn-sm btn btn-red btn-shadow`} style={{ width: "100%" }}>
                                                                {t("account.banUser")}
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <div className="col col-conversar col-button-account">
                                                            <a href="#" className="btn-w-100 btn-sm btn btn-blue" data-bs-toggle="modal" data-bs-target="#modal-desbanir" style={{ width: "100%" }}>
                                                                {t("account.unbanUser")}
                                                            </a>
                                                        </div>
                                                    )}
                                                </>
                                            ) : null}
                                        </div>
                                    </div>

                                        <div className="row row-filtro-account" style={{ margin: 0, width: "100%" }}>
                                            {user?.is_visible === false && (
                                                <>
                                                    {!loading && <div className="col">
                                                        <h3 style={{ textAlign: "center" }}>{t("account.privateProfile")}</h3>
                                                    </div>}
                                                </>
                                            )}

                                            {(user?.is_visible !== false && user?.id) && !loading ? (() => {
                                                    const isMobile = window.innerWidth <= 850;

                                                    const allTabs = [
                                                        {
                                                            key: "all" as EnumContent,
                                                            always: true,
                                                            node: (extraClass = "") => (
                                                                <div key="all" onClick={() => handleChangecontentAccount("all")} className={`col ${user?.active_frame?.image_path ? "icon-filtro-account-has-frame" : ""} ${contentAccount == "all" ? "icone-conta-ativo" : ""} cursor-pointer ${extraClass}`}>
                                                                    <svg style={{ opacity: 0.5 }} xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="icon-fillter bi bi-postcard-heart icone-conta" viewBox="0 0 16 16">
                                                                        <path d="M8 4.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Zm3.5.878c1.482-1.42 4.795 1.392 0 4.622-4.795-3.23-1.482-6.043 0-4.622ZM2.5 5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" />
                                                                        <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2Z" />
                                                                    </svg>
                                                                </div>
                                                            ),
                                                        },
                                                        {
                                                            key: "photos" as EnumContent,
                                                            always: true,
                                                            node: (extraClass = "") => (
                                                                <div key="photos" onClick={() => handleChangecontentAccount("photos")} className={`col ${contentAccount == "photos" ? "icone-conta-ativo" : ""} cursor-pointer ${extraClass}`}>
                                                                    <ImageIcon style={{ opacity: 0.5 }} className="icon-fillter bi bi-chat-square-text icone-conta" data-feather="book-open" />
                                                                </div>
                                                            ),
                                                        },
                                                        ...(user?.total_videos_youtube > 0 || user?.id == userAuthenticated.id ? [{
                                                            key: "musics" as EnumContent,
                                                            always: false,
                                                            node: (extraClass = "") => (
                                                                <div key="musics" onClick={() => { handleChangecontentAccount("musics"); setOpenTabsSheet(false); }} className={`col ${contentAccount == "musics" ? "icone-conta-ativo" : ""} cursor-pointer ${extraClass}`}>
                                                                    <Music2 style={{ opacity: 0.5 }} className="icon-fillter bi bi-chat-square-text icone-conta" data-feather="book-open" />
                                                                </div>
                                                            ),
                                                        }] : []),
                                                        ...(watchedMedia.length > 0 || user?.id == userAuthenticated?.id ? [{
                                                            key: "filmes" as EnumContent,
                                                            always: false,
                                                            node: (extraClass = "") => (
                                                                <div key="filmes" onClick={() => { handleChangecontentAccount("filmes"); setOpenTabsSheet(false); }} className={`col ${contentAccount == "filmes" ? "icone-conta-ativo" : ""} cursor-pointer ${extraClass}`}>
                                                                    <Video style={{ opacity: 0.5 }} className="icon-fillter icone-conta" />
                                                                </div>
                                                            ),
                                                        }] : []),
                                                        ...(user?.total_poems > 0 ? [{
                                                            key: "poems" as EnumContent,
                                                            always: false,
                                                            node: (extraClass = "") => (
                                                                <div key="poems" onClick={() => { handleChangecontentAccount("poems"); setOpenTabsSheet(false); }} className={`col ${contentAccount == "poems" ? "icone-conta-ativo" : ""} cursor-pointer ${extraClass}`}>
                                                                    <ScrollText style={{ opacity: 0.5 }} className="icon-fillter bi bi-chat-square-text icone-conta" data-feather="book-open" />
                                                                </div>
                                                            ),
                                                        }] : []),
                                                        ...(isMobile ? [{
                                                            key: "communities" as EnumContent,
                                                            always: false,
                                                            node: (extraClass = "") => (
                                                                <div key="communities" onClick={() => { handleChangecontentAccount("communities"); setOpenTabsSheet(false); }} className={`user-select-none col ${contentAccount == "communities" ? "icone-conta-ativo" : ""} cursor-pointer ${extraClass}`}>
                                                                    <Icon size={24} style={{}} invertColor={!isDarkMode} name="diversity_1">
                                                                        <Users opacity={.6} size={23}/>
                                                                    </Icon>
                                                                </div>
                                                            ),
                                                        }] : []),
                                                    ];

                                                    const shouldTruncate = isMobile && allTabs.length > 4;
                                                    const visibleTabs = shouldTruncate ? allTabs.slice(0, 3) : allTabs;
                                                    const overflowTabs = shouldTruncate ? allTabs.slice(3) : [];

                                                    return (
                                                        <>
                                                            {visibleTabs.map(tab => tab.node())}

                                                            {shouldTruncate && (
                                                                <div
                                                                    className={`col cursor-pointer ${overflowTabs.some(t => t.key === contentAccount) ? "icone-conta-ativo" : ""}`}
                                                                    onClick={() => setOpenTabsSheet(true)}
                                                                >
                                                                    <Info style={{ opacity: 0.5 }} className="icon-fillter icone-conta" />
                                                                </div>
                                                            )}
                                                        </>
                                                    );
                                                })() : null}
                                        </div>

                                <div className={`image-overlay ${openImage != null ? "active" : ""}`} onClick={() => setOpenImage(null)} >
                                    <button type="button" onClick={() => setOpenImage(null)} className="btn-x-right btn-close svg-icons-color btn-dark">
                                        <X/>
                                    </button>
                                </div> 
                            </div> 

                            <div className="bg-account">
                                {/* CONTEUDO */}
                                <div className={`row padding-mobile-account ${contentAccount == "all" || contentAccount == "poems" || contentAccount == "communities" ? "row-conteudo-all": ""}`} style={{ justifyContent: "start", margin: 0, opacity: user?.is_banned ? .5 : 1 }}>
                                    {/* FOTOS */}
                                    {!contentAccount || contentAccount == "photos" ? (
                                        <div className="row user-select-none post-img post-img-account-here" style={{ margin: "0px 0 20px 0", padding: 0 }}>
                                            {user && user?.is_visible === false ? (
                                                <h3 className="text-center mt-4">
                                                    {/* Perfil Privado */}
                                                </h3>
                                            ) : (
                                                <>

                                                    {photoPosts && photoPosts?.length > 0 ? (
                                                        <>
                                                            {photoPosts.map((photoPost, index) => (
                                                                // data-bs-toggle="modal" data-bs-target={`#modal-img`}
                                                                <div
                                                                    style={{ position: "relative" }}
                                                                    className="col-lg-4 col-6 card-post-img"  
                                                                    key={photoPost.id} id={`photo-${photoPost.id}`}
                                                                    onClick={() => {
                                                                        const postId = photoPost.id;
                                                                        const post = photoPosts.find(p => p.id === postId);
                                                                        if (post) {
                                                                            setSelectedPhotoPost(post);
                                                                            // Encontra o índice da imagem clicada dentro do post
                                                                            const imgIndex = post.images
                                                                                ?.filter(img => img.type === 0)
                                                                                .findIndex(img => img.id === photos[index].id) ?? 0;
                                                                            setSelectedPhotoIndex(imgIndex >= 0 ? imgIndex : 0);
                                                                            setIsImageModalOpen(true);
                                                                        }
                                                                    }}
                                                                    >
                                                                        {photoPost.images.length > 1 && (
                                                                            <>
                                                                                <GalleryHorizontalEnd style={{ position: "absolute", right: 10, top: 10, zIndex: 9 }}/>
                                                                            </>
                                                                        )}
                                                                    <img
                                                                        className={`${ openImage == index ? "image-open" : "" } cursor-pointer card card-post-account`}
                                                                        src={`${getImagePath(photoPost.images[0].path)}`}
                                                                        alt=""
                                                                        onError={(e) => {
                                                                            const target = e.currentTarget as HTMLImageElement;
                                                                            target.src = "/img/image_not_found.png";
                                                                        }}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </>
                                                    ) : (
                                                        <>
                                                        </>
                                                    )}

                                                    {(!isLoadingImages && user?.name && photos.length <= 0) || (endPhotos && photos.length <= 0) ? (
                                                        <div className="user-select-none row" style={{marginTop: "40px", marginBottom: "40px"}}>
                                                            <span className="span-empty">
                                                                <ImageOff className="icon-empty" />
                                                                <h3 className="w-100 text-center">{t("empty.images")}</h3>
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <>

                                                            {isLoadingImages && !endPhotos ? (
                                                                
                                                                    <>
                                                                    {[...Array(9)].map((_, index) => (
                                                                        <div key={index} className="col-lg-4 col-6 card-post-img" style={{ cursor: "-moz-grab!important" }}>
                                                                            <span className="cursor-pointer card card-post-account placeholder" style={{width: "100%", height: "100%"}}/>
                                                                        </div>
                                                                    ))}
                                                                    </>
                                                                    
                                                            ) : null}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    ) : null}

                                    {/* POSTS */}
                                    {contentAccount == "all" || contentAccount == "poems" ? (
                                        <div className="post-tudo row-account-padding row" style={{ margin: "0", padding: 0, width: "100%", justifyContent: "space-around", flexWrap: "wrap" }}>
                                            {contentAccount == "all" || (contentAccount == "poems" && window.innerWidth >= 850) ? (
                                                <div className={`col-5 col-info-user`}>
                                                    {user?.can_ban_user && isBanned ? (
                                                        <div>
                                                            <p style={{ marginBottom: 2 }}>{isBanned === true ? t("user.bannedForever") : t("user.bannedUntil", { date: new Date(isBanned).toLocaleString('pt-BR') })}</p>
                                                            {user?.ban_reason && (
                                                                <p style={{ fontSize: "12px", opacity: 0.7, marginBottom: 0, wordBreak: "break-word" }}>
                                                                    <strong>Motivo:</strong> {user.ban_reason.split(/<br\s*\/?>/i)[0].trim()}
                                                                </p>
                                                            )}
                                                        </div>
                                                    ): null}

                                                    {loading || firstLoad.current ? (
                                                        <>
                                                            <div className="mt-2 none-cel">
                                                                <span className="placeholder" style={{width: "100%", height: "20px", marginBottom: 0}}></span>
                                                            </div>
                                                            <div className="none-cel">
                                                                <span className="placeholder" style={{width: "70%", height: "20px", marginBottom: 0}}></span>
                                                            </div>
                                                            <div className="none-cel">
                                                                <span className="placeholder" style={{width: "40%", height: "20px", marginBottom: 0}}></span>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                        {user?.is_visible !== false && <h4>{t("user.personalInfo.title")}</h4>}
                                                        
                                                        {user?.id ? (
                                                            <p>
                                                                <Info className="icon-info-user"/>
                                                                {t("user.userNumber", { id: user?.id })}
                                                            </p>
                                                        ) : null}

                                                        {user?.created_at ? (
                                                            <p>
                                                                <Calendar className="icon-info-user"/> 
                                                                {t("user.personalInfo.inPacoca")} {(() => {
                                                                    const d = new Date(user?.created_at);
                                                                    const dia = d.getDate().toString().padStart(2, "0");
                                                                    const mes = (d.getMonth() + 1).toString().padStart(2, "0");
                                                                    const ano = d.getFullYear();
                                                                    const hora = d.getHours().toString().padStart(2, "0");
                                                                    const minuto = d.getMinutes().toString().padStart(2, "0");
                                                                    return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
                                                                })()}
                                                            </p>
                                                        ) : null}
                                                        
                                                        {user?.streak?.current ? (
                                                            <p style={{ display: "flex", alignItems: "center" }}>
                                                                <Icon style={{ marginRight: -2 }} size={26} name="local_fire_department" invertColor={!isDarkMode} className="icon-info-user">
                                                                    <Flame className="icon-info-user"/>
                                                                </Icon> 
                                                                {t("generics.days", { count: user.streak.current })}
                                                            </p>
                                                        ) : null}

                                                        {user?.weekly_rank ? (
                                                            <p onClick={() => navigate("/ranking")} style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                <Icon style={{ marginRight: -2 }} size={26} name={user.weekly_rank <=5 ? "social_leaderboard" : "leaderboard"} invertColor={!isDarkMode} className="icon-info-user"> 
                                                                    {user.weekly_rank <=5 ? <Medal className="icon-info-user"/> : <Podium className="icon-info-user"/> }
                                                                </Icon>
                                                                
                                                                {user.weekly_rank}
                                                            </p>
                                                        ) : null}

                                                        {isSuper(true) ? (
                                                            <>
                                                                <p>
                                                                    <Mail className="icon-info-user"/>
                                                                    {user?.email}
                                                                    {/* {t("user.personalInfo.email", { email: user?.email })} */}
                                                                </p>
                                                                {user?.phone && (
                                                                    <p>
                                                                        <Phone className="icon-info-user"/>
                                                                        {user?.phone}
                                                                        {/* {t("user.personalInfo.phone", { phone: user?.phone })} */}
                                                                    </p>
                                                                )}
                                                            </>
                                                        ) : null}

                                                        {user?.birth_date ? (
                                                            <p> 
                                                                <Cake className="icon-info-user"/>
                                                                {(new Date(user?.birth_date).getDate() + 1).toString().padStart(2, "0")}/{(new Date(user?.birth_date).getMonth() + 1).toString().padStart(2, "0")}/{new Date(user?.birth_date).getFullYear()}
                                                                {/* {t("user.personalInfo.birthDate", { date: `${(new Date(user?.birth_date).getDate() + 1).toString().padStart(2, "0")}/${(new Date(user?.birth_date).getMonth() + 1).toString().padStart(2, "0")}/${new Date(user?.birth_date).getFullYear()}` })} */}
                                                            </p>
                                                        ) : null}

                                                        {user?.sexo ? (
                                                            <p>
                                                                <VenusAndMars className="icon-info-user"/>
                                                                {user?.sexo}
                                                                {/* {t("user.personalInfo.gender", { gender: user?.sexo  })} */}
                                                            </p>
                                                        ) : null}

                                                        {user?.relationship ? (
                                                            <p>
                                                                <Heart className="icon-info-user"/>
                                                                {t(`profile.relationship.${user?.relationship}`)}
                                                            </p>
                                                        ) : null}

                                                        {user?.pronoun ? (
                                                            <p>
                                                                <MessageCircle className="icon-info-user"/>
                                                                {t(`profile.pronoun.${user?.pronoun}`)}
                                                            </p>
                                                        ) : null}

                                                        {user?.country ? (
                                                            <p> 
                                                                <MapPinned className="icon-info-user"/> 
                                                                {t(`countries.${user?.country}`)}
                                                            </p>
                                                        ) : null}

                                                        {user?.is_company && user?.is_verified_company && user.company ? (
                                                            <>
                                                                <h4 className="title-location">{t("user.personalInfo.company")}</h4>
                                                                <p>
                                                                    <Building className="icon-info-user"/>
                                                                    {user?.company.corporate_reason}
                                                                </p>
                                                                <p>
                                                                    <Building2 className="icon-info-user"/>
                                                                    {user?.company.business_name}
                                                                </p>
                                                                <p>
                                                                    <PanelsTopLeft className="icon-info-user"/>
                                                                    {user?.company.website}
                                                                </p>
                                                            </>
                                                        ): null}

                                                        {user?.can_see_location ? (
                                                            <>
                                                            
                                                                {user?.location?.ip_address ? (
                                                                    <>
                                                                        <h4 className="title-location">{t("user.personalInfo.location.title")}</h4>
                                                                        <p className="cursor-pointer" onClick={() => navigate(`/moderador/usuarios-por-ip/${user?.location?.ip_address}`)}>
                                                                            <Locate className="icon-info-user"/>
                                                                            {t("user.personalInfo.location.ipAddress", { ip: user?.location?.ip_address ?? "--" })}
                                                                        </p>
                                                                        <p>
                                                                            <MapPlus className="icon-info-user"/>
                                                                            {t("user.personalInfo.location.region", { region: user?.location?.region_name ?? "--" })}
                                                                        </p>
                                                                        <p>
                                                                            <MapPin className="icon-info-user"/>
                                                                            {t("user.personalInfo.location.city", { city: user?.location?.city ?? "--" })}
                                                                        </p>
                                                                </>
                                                                ) : null}
                                                            </>
                                                        ): null}

                                                        {!!user?.custom_fields?.length && (
                                                            <>
                                                                {!showMoreInfo && window.innerWidth <=850 && (
                                                                    <p className="user-select-none load-more-info-user" onClick={() => setShowMoreInfo(true)}>
                                                                        {t("account.loadMore")}
                                                                    </p>
                                                                )}

                                                                {(showMoreInfo || window.innerWidth > 850) && (
                                                                    <>
                                                                        {user?.custom_fields?.map((field, index) => (
                                                                            <div key={index} className="mb-3">

                                                                                <h4 className="title-location">
                                                                                    {t(`profile.fields.${field.key}`)}
                                                                                </h4>

                                                                                <div className="d-flex flex-wrap gap-2">
                                                                                    {field?.values?.map((value, i) => (
                                                                                        <span key={i} className="badge badge-more-info">
                                                                                            {value}
                                                                                        </span>
                                                                                    ))}
                                                                                </div>

                                                                            </div>
                                                                        ))}
                                                                    </>
                                                                )}
                                                            </>
                                                        )}
                                                    </>
                                                )}

                                                    
                                                    {user?.is_visible !== false && userName ? (
                                                        <ContributionGraph userName={userName} />
                                                    ) : null}
                                                </div>
                                            ): null}

                                            <div className="col-7 mb-4 post-account-here" style={{ padding: 0 }}>
                                                <div className="post-account-here" style={{ padding: 0 }}>
                                                    {/* Active filters banner */}
                                                    {contentAccount === "all" && hasActiveFilters && (
                                                        <div className="post-filter-active-bar">
                                                            <SlidersHorizontal size={14} />
                                                            <span>{t("account.filterPosts.activeFilters")}</span>
                                                            <button type="button" className="post-filter-active-bar-clear" onClick={() => { clearPostFilters(); }}>
                                                                <X size={13} /> {t("account.filterPosts.clear")}
                                                            </button>
                                                        </div>
                                                    )}
                                                    <PostList onOpenComments={(idPost) => {setShowModalComments(true); setIdPostSelected(idPost)}} onOpenLikes={(idPost) => {setShowModalLikes(true); setIdPostSelected(idPost)}} posts={visiblePosts} setPosts={isPoems ? setPoems : setPosts} />
                                                    {!isLoadingPosts && visiblePosts.length <= 0 && !notFound ? (
                                                        <>
                                                            {firstLoadPost.current ? (
                                                                <PostLoading loading={true}/>
                                                            ) : (
                                                                <>
                                                                    {user?.is_visible !== false && (
                                                                        <div className="user-select-none row" style={{ marginTop: "24px", width: "100%", marginLeft: "0", marginRight: "0" }}>
                                                                            <span className="span-empty" style={{width: "100%"}}>
                                                                                <KeyboardOff className="icon-empty" />
                                                                                <h3 className="w-100 text-center">{t("empty.postsAccount")}</h3>
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <PostLoading loading={isLoadingPosts}/>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}

                                    {contentAccount == "communities" ? (
                                        <>
                                            <CommunitiesContent statusMembers={statusCommunities} communities={communities} termo={termo3} handleChange={handleChange3} handleKeyDown={handleKeyDown3} user={user}/>
                                        </>
                                    ): null}
                                </div>
                            </div>
                        </div>
                    </div>

                        <GiveCoffee user={user}/>
                        <GiveCoffeeBottom open={openGiveCoffee} setOpen={setOpenGiveCofee} user={user}/>
                    </div>
                </>
            ) : (
                <>
                    {notFound || errorLoad ? (
                        <div className="container-404">
                            <Helmet>
                                <title>Paçoca - {notFound ? "404" : "500"}</title>
                            </Helmet>

                            <div className="col d-flex" style={{ alignItems: "center", flexDirection: "column" }}>
                                <h1>{notFound ? "404" : "500"}</h1>
                                <h3 style={{ textAlign: "center" }}>{notFound ? t("user.notFound") : t("user.fetchError")}</h3>
                                <UserX style={{ height: "100px", width: "100px", margin: "100px 0" }} />
                                <Link to="/">{t("generics.back")}</Link>
                            </div>
                        </div>
                    ) : (
                        <>
                            <Helmet>
                                <title>Paçoca {userName ? `- @${userName}` : ""}</title>
                            </Helmet>
                            {loading ? (
                                <div className="container-404">
                                    <LoadingThreeCircle style={{justifyContent: "center"}}/>
                                    {/* <Spinner size="50px" className="text-primary" /> */}
                                </div>
                            ) : null}
                        </>
                    )}
                </>
            )}
            
            <div ref={endOfListRef} style={{ height: "0px" }}></div>
            {/* <OpenImg id={`modal-img`} path={imgPath} />
            <div className={`image-overlay ${openImage != null ? "active" : ""}`} onClick={() => setOpenImage(null)} >
                <button type="button" onClick={() => setOpenImage(null)} className="btn-x-right btn-close svg-icons-color btn-dark">
                    <X/>
                </button>
            </div>  */}
            <ImageModal
                open={isImageModalOpen}
                post={selectedPhotoPost ?? undefined}
                images={selectedPhotoPost?.images}
                initialIndex={selectedPhotoIndex}
                onClose={() => {
                    setIsImageModalOpen(false);
                    setSelectedPhotoPost(null);
                }}
                username={selectedPhotoPost?.user?.user_name}
                img_account={selectedPhotoPost?.user?.img_account}
                likes={selectedPhotoPost?.total_likes}
                comments={selectedPhotoPost?.total_comments}
                isLiked={selectedPhotoPost?.liked}
                setPost={(updater) => {
                    setSelectedPhotoPost(prev => {
                        const next = typeof updater === 'function' ? updater(prev) : updater;
                        // Sincroniza também em photoPosts
                        if (next) {
                            setPhotoPosts(prevPosts =>
                                prevPosts.map(p => p.id === next.id ? next : p)
                            );
                        }
                        return next;
                    });
                }}
                setPosts={setPhotoPosts}
                getImagePath={getImagePath}
                onLike={() => {}} // mantém o botão de like visível
                onComment={() => {
                    setIdPostSelected(selectedPhotoPost?.id ?? null);
                    setShowModalComments(true);
                }}
            />
            
            <button className="d-none" ref={openImgRef} data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#modal-img">a</button>
            <ModalPostLikes idPostSelected={idPostSelected} show={showModalLikes} />
            {window.innerWidth <= 850 ? <ModalCommentsBottom setOpen={setShowModalComments} open={showModalComments} idPostSelected={idPostSelected}/> : <ModalComments idPostSelected={idPostSelected} show={showModalComments} />}

            {/* Dropdown sob a foto de perfil */}
            {openProfileOptions && (
                <BottomSheet
                    disableDrag
                    snapPoints={[0, 0.3, 1]}
                    initialSnap={1}
                    open={openProfileOptions}
                    setOpen={setOpenProfileOptions}
                >
                    <div className="modal-body modal-body-likes overflow-minus bottom-sheet-profile-settings"style={{ marginTop: 10, marginLeft: 5 }} onClick={() => setOpenProfileOptions(false)}>

                        {/* Ver foto de perfil */}
                        <div className="dropdown-item cursor-pointer user-select-none"
                            onClick={() => {
                                setOpenProfileOptions(false);
                                setOpenImage(-1);
                            }}
                        >
                            <div className="div-icon-fix">
                                <div className="div-icon-block">
                                    <ImageIcon className="icon-config-post" size={20} />
                                    <span>{t("account.viewProfilePhoto")}</span>
                                </div>
                            </div>
                        </div>

                        {/* Ver stories — só se tiver stories */}
                        {user?.has_stories && (
                            <div className="dropdown-item cursor-pointer user-select-none"
                                onClick={() => {
                                    setOpenProfileOptions(false);
                                    fetchAndOpenStory(); // ← reusa a mesma função, sem storyId abre o primeiro
                                }}
                            >
                                <div className="div-icon-fix">
                                    <div className="div-icon-block">
                                        <PanelsTopLeft className="icon-config-post" size={20} />
                                        <span>{t("account.viewStories")}</span>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Editar — só para o próprio usuário */}
                        {user?.id === userAuthenticated?.id && !removeToNativeiOS(userAuthenticated?.id) && (
                            <div className="dropdown-item cursor-pointer user-select-none"
                                onClick={() => {
                                    setOpenProfileOptions(false);
                                    inputRef.current?.click();
                                }}
                            >
                                <div className="div-icon-fix">
                                    <div className="div-icon-block">
                                        <Pencil className="icon-config-post" size={20} />
                                        <span>{t("account.changeProfilePhoto")}</span>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Remover moldura — só para o próprio usuário com moldura ativa */}
                        {(user?.can_remove_photo || user?.id === userAuthenticated?.id) && user?.active_frame && (
                            <div className="dropdown-item cursor-pointer user-select-none"
                                onClick={async () => {
                                    setOpenProfileOptions(false);
                                    try {
                                        await axios.post(`${PACOCA_API_URL}/frames/remove`, {}, {
                                            headers: { Authorization: `Bearer ${token}` }
                                        });
                                        setUserAuthenticated(prev => prev ? { ...prev, active_frame: undefined } : prev);
                                        setUser(prev => prev ? { ...prev, active_frame: undefined } : prev);
                                        setMessage(t("frames.frameRemoved"), "success");
                                    } catch (err) {
                                        setMessage(errorMessage(err), "error");
                                    }
                                }}
                            >
                                <div className="div-icon-fix">
                                    <div className="div-icon-block">
                                        <Trash2 className="icon-config-post" size={20} />
                                        <span>{t("frames.removeFrame")}</span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </BottomSheet>
            )}

            <BottomSheet
                disableDrag
                snapPoints={[0, 0.4, 1]}
                initialSnap={1}
                open={openTabsSheet}
                setOpen={setOpenTabsSheet}
            >
                <div className="modal-body modal-body-likes overflow-minus" style={{ marginTop: 10, marginLeft: 5 }}>
                    {(() => {
                        const isMobile = window.innerWidth <= 850;
                        const allTabs = [
                            { key: "all" as EnumContent, label: t("account.tabs.all"), icon: <svg style={{ opacity: 0.5 }} xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="icon-fillter bi bi-postcard-heart icone-conta" viewBox="0 0 16 16"><path d="M8 4.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Zm3.5.878c1.482-1.42 4.795 1.392 0 4.622-4.795-3.23-1.482-6.043 0-4.622ZM2.5 5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" /><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2Z" /></svg>, show: true },
                            { key: "photos" as EnumContent, label: t("account.tabs.photos"), icon: <ImageIcon style={{ opacity: 0.5 }} className="icon-fillter icone-conta" />, show: true },
                            { key: "musics" as EnumContent, label: t("account.tabs.musics"), icon: <Music2 style={{ opacity: 0.5 }} className="icon-fillter icone-conta" />, show: user?.total_videos_youtube && user?.total_videos_youtube > 0 || user?.id == userAuthenticated?.id },
                            { key: "filmes" as EnumContent, label: t("account.tabs.filmes"), icon: <Video style={{ opacity: 0.5 }} className="icon-fillter icone-conta" />, show: watchedMedia.length > 0 || user?.id == userAuthenticated?.id },
                            { key: "poems" as EnumContent, label: t("account.tabs.poems"), icon: <ScrollText style={{ opacity: 0.5 }} className="icon-fillter icone-conta" />, show: user?.total_poems && user?.total_poems > 0 },
                            { key: "communities" as EnumContent, label: t("account.tabs.communities"), icon: <Icon size={24} style={{}} invertColor={!isDarkMode} name="diversity_1"><Users opacity={.6} size={23}/></Icon>, show: isMobile },
                        ].filter(tab => tab.show);

                        const overflowTabs = allTabs.length > 4 ? allTabs.slice(3) : allTabs;

                        return overflowTabs.map(tab => (
                            <div
                                key={tab.key}
                                className={`dropdown-item cursor-pointer user-select-none d-flex align-items-center gap-3 ${contentAccount === tab.key ? "icone-conta-ativo" : ""}`}
                                style={{ padding: "12px 8px" }}
                                onClick={() => { handleChangecontentAccount(tab.key); setOpenTabsSheet(false); }}
                            >
                                {tab.icon}
                                <span style={{ fontSize: 15 }}>{tab.label}</span>
                            </div>
                        ));
                    })()}
                </div>
            </BottomSheet>

            {/* ── Post filter — MOBILE: bottom sheet ── */}
            <BottomSheet
                open={openPostFilters}
                setOpen={setOpenPostFilters}
                hasXClose
                disableDrag={false}
                snapPoints={[0, 1]}
                initialSnap={1}
                title={
                    <div className="sf-bs-header">
                        <span className="sf-bs-title">{t("account.filterPosts.title")}</span>
                    </div>
                }
            >
                <div className="sf-bs-content scroll-fino">
                    <AccountFilterContent
                        filterKeywordInput={filterKeywordInput}
                        setFilterKeywordInput={setFilterKeywordInput}
                        filterOldestFirst={filterOldestFirst}
                        setFilterOldestFirst={setFilterOldestFirst}
                        filterHasLink={filterHasLink}
                        setFilterHasLink={setFilterHasLink}
                        filterMediaType={filterMediaType}
                        setFilterMediaType={setFilterMediaType}
                        onApply={() => { applyPostFilters({ keyword: filterKeywordInput, oldestFirst: filterOldestFirst, hasLink: filterHasLink, mediaType: filterMediaType }); closeFilterPanel(); }}
                        onClear={() => { clearPostFilters(); closeFilterPanel(); }}
                    />
                </div>
            </BottomSheet>

            {/* ── Post filter — DESKTOP: side panel ── */}
            {filterPanelRendered && (
                <>
                    <div
                        className={`sf-backdrop ${filterPanelEntering ? "sf-backdrop-in" : ""}`}
                        onClick={closeFilterPanel}
                    />
                    <div className={`sf-panel ${filterPanelEntering ? "sf-panel-in" : ""}`} role="dialog">
                        <div className="sf-panel-header">
                            <span className="sf-panel-title">{t("account.filterPosts.title")}</span>
                            <button className="sf-panel-close" onClick={closeFilterPanel} aria-label="Fechar">
                                <X size={18} />
                            </button>
                        </div>
                        <div className="sf-panel-scroll scroll-fino">
                            <AccountFilterContent
                                filterKeywordInput={filterKeywordInput}
                                setFilterKeywordInput={setFilterKeywordInput}
                                filterOldestFirst={filterOldestFirst}
                                setFilterOldestFirst={setFilterOldestFirst}
                                filterHasLink={filterHasLink}
                                setFilterHasLink={setFilterHasLink}
                                filterMediaType={filterMediaType}
                                setFilterMediaType={setFilterMediaType}
                                onApply={() => { applyPostFilters({ keyword: filterKeywordInput, oldestFirst: filterOldestFirst, hasLink: filterHasLink, mediaType: filterMediaType }); closeFilterPanel(); }}
                                onClear={() => { clearPostFilters(); closeFilterPanel(); }}
                            />
                        </div>
                    </div>
                </>
            )}

            {activeUserIndex !== null && usersStoriesProfile.length > 0 && (
                <StoryViewer
                    usersStories={usersStoriesProfile}
                    userIndex={activeUserIndex}
                    storyIndex={activeStoryIndex}
                    setUserIndex={setActiveUserIndex}
                    setStoryIndex={setActiveStoryIndex}
                    onClose={() => {
                        setActiveUserIndex(null);
                        // Remove o query param da URL sem recarregar a página
                        searchParams.delete("story");
                        searchParams.delete("comments");
                        window.history.replaceState({}, "", window.location.pathname);
                    }}
                    onStoryDeleted={handleStoryDeleted}
                    initiallyShowComments={shouldOpenStoryComments}
                />
            )}
        </>
    );
};

function FollowersContent({statusMembers, members, user, termo, handleKeyDown, handleChange}: { statusMembers: StatusString, members: User[], termo: string,handleChange: any, handleKeyDown: any, user: User | null }){
    return (
        <>
            {statusMembers == StatusString.error ? (
                <IconLateralContent text={t("errors.find.followers")}/>
            ): (
                <>
                    {Number(user?.total_followers) >11 ? (
                        <div className="d-flex mb-3">
                            <input id="input-search-screen" className="form-control input-search input-search-screen" type="text" name="search" placeholder="Pesquisar" aria-label="Search" value={termo} onChange={handleChange} onKeyDown={handleKeyDown} required />
                            <button onClick={() => {}} className="btn-search btn-search-screen input-search-screen-icon-menu-dark btn" type="button" title="Buscar">
                                <Search color="#d3d3d3" />
                            </button>
                        </div>
                    ) : null}

                    {statusMembers == StatusString.success && !members.length ? (
                        <IconLateralContent icon={<UserMinus2 size={40}/>} text={t("empty.followers")}/>
                    ): null}
                    <UserSearchLoadin loading={statusMembers == StatusString.loading}/>
                    {members.map((u, index) => (
                        <UserSearch isBtnFollowUser={false} key={index} clasNameSearch="name-communities" clasImgAccount="img-user-left" user={u} />
                    ))}
                </>
            )}
        </>
    );
}

function FollowingContent({statusMembers, members, user, termo, handleKeyDown, handleChange}: { statusMembers: StatusString, members: User[], termo: string,handleChange: any, handleKeyDown: any, user: User | null }){
    return (
        <>
            {statusMembers == StatusString.error ? (
                <IconLateralContent text={t("errors.find.following")}/>
            ): (
                <>
                    {Number(user?.total_following) >11 ? (
                        <div className="d-flex mb-3">
                            <input id="input-search-screen" className="form-control input-search input-search-screen" type="text" name="search" placeholder="Pesquisar" aria-label="Search" value={termo} onChange={handleChange} onKeyDown={handleKeyDown} required />
                            <button onClick={() => {}} className="btn-search btn-search-screen input-search-screen-icon-menu-dark btn" type="button" title="Buscar">
                                <Search color="#d3d3d3" />
                            </button>
                        </div>
                    ) : null}

                    {statusMembers == StatusString.success && !members.length ? (
                        <IconLateralContent icon={<UserMinus2 size={40}/>} text={t("empty.following")}/>
                    ): null}
                    <UserSearchLoadin loading={statusMembers == StatusString.loading}/>
                    {members.map((u, index) => (
                        <UserSearch isBtnFollowUser={false} key={index} clasNameSearch="name-communities" clasImgAccount="img-user-left" user={u} />
                    ))}
                </>
            )}
        </>
    );
}

function CommunitiesContent({statusMembers, communities, user, termo, handleKeyDown, handleChange}: { statusMembers: StatusString, communities: Community[], termo: string,handleChange: any, handleKeyDown: any, user: User | null }){
    const navigate = useNavigate();

    return (
        <>
            {statusMembers == StatusString.error ? (
                <IconLateralContent text={t("errors.find.communities")}/>
            ): (
                <>
                    {Number(communities.length) >=11 ? (
                        <div className="d-flex mb-3">
                            <input id="input-search-screen" className="form-control input-search input-search-screen" type="text" name="search" placeholder="Pesquisar" aria-label="Search" value={termo} onChange={handleChange} onKeyDown={handleKeyDown} required />
                            <button onClick={() => {}} className="btn-search btn-search-screen input-search-screen-icon-menu-dark btn" type="button" title="Buscar">
                                <Search color="#d3d3d3" />
                            </button>
                        </div>
                    ) : null}

                    {statusMembers == StatusString.success && !communities.length ? (
                        <IconLateralContent icon={<UserMinus2 size={40}/>} text={t("empty.communitys")}/>
                    ): null}
                    <UserSearchLoadin loading={statusMembers == StatusString.loading}/>
                    {/* {communities.map((u, index) => (
                        <UserSearch isBtnFollowUser={false} key={index} clasImgAccount="img-preview" user={u} />
                    ))} */}
                    {communities?.map((community, index) => (
                        <div key={index} className="notification_opened row-notification open-notification row-user">
                            <img className="user-select-none col-1 img-community-left" src={getImagePathBucketPacoca(community.img, getImageNotFound(community.name))} onError={(e) => { e.currentTarget.src = getImageNotFound(community.name); }} />
                            <div className="col" style={{ paddingLeft: "5px", overflow: "hidden",  }} onClick={() => navigate(`/comunidades/${community.id}`)}>
                                <h5 className="h5-name-search name-card-search-user" style={{ overflowWrap: "anywhere", whiteSpace: "nowrap", overflow: "hidden", marginBottom: "2px" }}>
                                    <Link className="name-communities" style={{ marginRight: 5 }} to={`/comunidades/${community.id}`}>{community?.name}</Link>
                                </h5>
                                <p className="username-search" style={{ whiteSpace: "nowrap", overflow: "hidden" }}>{community?.description}</p>
                            </div>
                        </div>
                    ))}
                </>
            )}
        </>
    );
}

/* ─── AccountFilterContent — filter body shared by mobile + desktop ─────── */
interface AccountFilterContentProps {
    filterKeywordInput: string;
    setFilterKeywordInput: (v: string) => void;
    filterOldestFirst: boolean;
    setFilterOldestFirst: (v: boolean | ((p: boolean) => boolean)) => void;
    filterHasLink: boolean;
    setFilterHasLink: (v: boolean | ((p: boolean) => boolean)) => void;
    filterMediaType: "" | "photos" | "videos";
    setFilterMediaType: (v: "" | "photos" | "videos") => void;
    onApply: () => void;
    onClear: () => void;
}

function AccountFilterContent({
    filterKeywordInput, setFilterKeywordInput,
    filterOldestFirst, setFilterOldestFirst,
    filterHasLink, setFilterHasLink,
    filterMediaType, setFilterMediaType,
    onApply, onClear,
}: AccountFilterContentProps) {
    const { t } = useTranslation();

    return (
        <div className="sf-panel-body">
            {/* Keyword */}
            <div className="sf-section-label">{t("account.filterPosts.keyword")}</div>
            <div className="sf-row sf-row-input" style={{ cursor: "default" }}>
                <span className="sf-row-text sf-input-label">
                    <div className="pf-keyword-row">
                        <Search size={15} className="pf-keyword-icon" />
                        <input
                            className="sf-input"
                            type="text"
                            placeholder={t("account.filterPosts.keywordPlaceholder")}
                            value={filterKeywordInput}
                            onChange={e => setFilterKeywordInput(e.target.value)}
                            onKeyDown={e => { if (e.key === "Enter") onApply(); }}
                        />
                        {filterKeywordInput && (
                            <button className="pf-keyword-clear" type="button" onClick={() => setFilterKeywordInput("")}>
                                <X size={13} />
                            </button>
                        )}
                    </div>
                </span>
            </div>

            {/* Ordenação */}
            <div className="sf-section-label">{t("account.filterPosts.options")}</div>

            <div
                className={`sf-row ${filterOldestFirst ? "sf-row-active" : ""}`}
                onClick={() => setFilterOldestFirst(p => !p)}
            >
                <span className="sf-row-text">{t("account.filterPosts.oldestFirst")}</span>
                {filterOldestFirst && <CheckCircle className="sf-check" size={18} />}
            </div>

            <div
                className={`sf-row ${filterHasLink ? "sf-row-active" : ""}`}
                onClick={() => setFilterHasLink(p => !p)}
            >
                <span className="sf-row-text">{t("account.filterPosts.hasLink")}</span>
                {filterHasLink && <CheckCircle className="sf-check" size={18} />}
            </div>

            {/* Tipo de mídia */}
            <div className="sf-section-label">{t("account.filterPosts.mediaType")}</div>

            <div
                className={`sf-row ${filterMediaType === "" ? "sf-row-active" : ""}`}
                onClick={() => setFilterMediaType("")}
            >
                <span className="sf-row-text">{t("account.filterPosts.mediaAll")}</span>
                {filterMediaType === "" && <CheckCircle className="sf-check" size={18} />}
            </div>

            <div
                className={`sf-row ${filterMediaType === "photos" ? "sf-row-active" : ""}`}
                onClick={() => setFilterMediaType("photos")}
            >
                <span className="sf-row-text">{t("account.filterPosts.mediaPhotos")}</span>
                {filterMediaType === "photos" && <CheckCircle className="sf-check" size={18} />}
            </div>

            <div
                className={`sf-row ${filterMediaType === "videos" ? "sf-row-active" : ""}`}
                onClick={() => setFilterMediaType("videos")}
            >
                <span className="sf-row-text">{t("account.filterPosts.mediaVideos")}</span>
                {filterMediaType === "videos" && <CheckCircle className="sf-check" size={18} />}
            </div>

            {/* Actions */}
            <div className="sf-actions">
                <button onClick={onClear} className="btn btn-danger sf-btn-clear">
                    {t("account.filterPosts.clear")}
                </button>
                <button onClick={onApply} className="btn btn-blue sf-btn-apply">
                    {t("account.filterPosts.apply")}
                </button>
            </div>
        </div>
    );
}

export default Account;
